import React, { Component } from "react";
import Loader from "../../../utils/Loader";
import { toast, ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import {
  cityActionId,
  countryActionId,
  adminUserRoleListActionId,
  toastError,
  toastSuccess,
  roleListActionId,
  exhibitionActionId,
  BASE_URL,
  downloadReport,
  normalizeMessage,
  primaryChapterListActionId,
  lengthActionId,
  breadthActionId,
  fullStallAreaActionId,
  stallSizeActionId,
  stateActionId,
  pincodeActionId,
  CFMActionId,
} from "../../../utils/constants";
import DatePicker from "react-datepicker";
import Footer from "../../../common_components/Footer";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import {
  getExhStallPossessionDetails_action,
  updateExhStallPossessionChecklist_action,
  tagDDSubmit_action
} from "../../../actions/admin_module_action/exhStallPossessionChecklist_action/exhStallPossessionChecklist_action";
import {
  getStallPossession_action,
  insertStallPossession_action,
} from "../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/stall_possession_action/stall_possession_action";
import { getDetails_spaceBooking_action } from "../../../actions/exhibitor_module_actions/space_booking_action/spaceBooking_action";
import { sendNoDues_action } from "../../../actions/admin_module_action/tax_invoice_action/tax_invoice_action";
import {
  emailValidator,
  mobileNoValidator,
  notMendetoryEmailValidator,
} from "../../../utils/Validator";
import ImageCapture from "../../../utils/ImageCapture";
import { download_no_due_action } from "../../../actions/admin_module_action/tax_invoice_action/tax_invoice_action";

class StallPossessionChecklistAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      exhibitionID: "",
      exhibitionList: [],
      basicDetailsList: [],
      checkList: [],
      SignaturePath: "",
      IsSignatureSaved: false,
      SignatureSaveFlag: false,
      RegistrationNO: "",
      hallId: "",
      stallId: "",
      Status: "",
      ITMEStaffName: "",
      IssuedDate: null,
      Remark: "",
      exhCompanyName: "",
      hallNo: "",
      stallNo: "",
      personName: "",
      companyName: "",
      stallPossessionId: "",
      countryId: "",
      contactNo: "",
      email: "",
      isAgree: true,
      remark: "",
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),

      // Err Msg
      personNameErr: "",
      companyNameErr: "",
      contactNoErr: "",
      emailErr: "",
      Status: "",
      ITMEStaffNameErr: "",
      IssuedDateErr: "",
      HallNo_StallNo: "",
      SignatureUUID: "",
      isOpen: false,
      iaMandatory: false,
      vendorList: [],
      vendorIndex: null,
      previousVendorData: [],
      isVendorDDView: false,
      exitPersonName: "",
      exitCompanyName: "",
      exitContactNo: "",
      exitEmail: "",
      exitPersonNameErr: "",
      exitCompanyNameErr: "",
      exitContactNoErr: "",
      exitEmailErr: "",
      isImageModal: false,
      VendorIndex: "",
      IsNDCIssued: false,
      IsAllChecked: false,
      isConfirm: false,
      vendorListIndex: '',
      ManualFormList: [],
      isNonEmpanelVendorPresent: false,
      isExhibitPop: false,
      subChapters: [],
      forcedDisable: false,
      forcedTempDisable: false,
      MFdeadline: '',
      PowerFormStatusID: null,
      waterFormStatusID: null,
      AirFormStatusID: null,
      barQuantityList: [],
      CFMQuantityList: [],
      inputList: [],
    };
    this.getFillList = this.getFillList.bind(this);
    this.checkRights = this.checkRights.bind(this);
  }

  componentDidMount() {
    this.getFillList(exhibitionActionId, "", "", "", "", "");
    this.getFillList(adminUserRoleListActionId, "", "", "", "", "");
    sessionStorage.setItem('ExhRegistrationIDSS', this.props.location.state != null &&
      this.props.location.state.ExhRegistrationID)
    sessionStorage.setItem('sessionExhibitionID', this.props.location.state != null &&
      this.props.location.state.ExhibitionID)
    this.setState(
      {
        ExhRegistrationID:
          this.props.location.state != null &&
          this.props.location.state.ExhRegistrationID,
        exhibitionID:
          this.props.location.state != null &&
          this.props.location.state.ExhibitionID,
        CompanyName:
          this.props.location.state != null &&
            this.props.location.state.CompanyName != null
            ? this.props.location.state.CompanyName
            : null,
        RegistrationNO:
          this.props.location.state != null &&
            this.props.location.state.RegistrationNO != null
            ? this.props.location.state.RegistrationNO
            : null,
        hallId:
          this.props.location.state != null &&
            this.props.location.state.hallId != null
            ? this.props.location.state.hallId
            : null,
        stallId:
          this.props.location.state != null &&
            this.props.location.state.stallId != null
            ? this.props.location.state.stallId
            : null,
        Status:
          this.props.location.state != null &&
            this.props.location.state.Status != null
            ? this.props.location.state.Status
            : null,
      },
      () => {
        this.getStallPossessionChecklistDetails();
        this.getStallPossession();
        this.getSpaceBookingDetails()
      }
    );
  }

  checkRights(id) {
    const { inputList } = this.state;
    const right = inputList.find(item => item.RightsID == id);
    return right ? !right.IsActive : false;
  }

  getSpaceBookingDetails() {
    const { ExhRegistrationID, exhibitionID } = this.state
    this.setState({ isLoading: true })
    this.props.getDetails_spaceBooking_action()
      .then((data) => {
        if (data.error != 1) {
          const countryId = data.data['registrationDetails'][0]['CountryID'] ? data.data['registrationDetails'][0]['CountryID'] : ''

          // Primary Chapter Name 
          const primaryChapterList = data.data['primaryChapterListDetails']['primaryChapter'].filter(obj => obj.IsSelect == true)
          const primaryChpName = primaryChapterList.length > 0 ? primaryChapterList[0].ChapterName : ''
          const PrimaryChapId = primaryChapterList.length > 0 ? primaryChapterList[0].ChapterID : ''
          this.setState({
            isShowExhPrimaryChapterComment: primaryChapterList.length > 1 ? true : false
          })

          // Chapter Level 2 Level 3 And Level 4
          var allChap = []
          const level2 = (data.data['primaryChapterListDetails']['level2'] || []).filter(obj => obj.IsSelect == true)
          allChap.push(...level2)
          const level3 = (data.data['primaryChapterListDetails']['level3'] || []).filter(obj => obj.IsSelect == true)
          allChap.push(...level3)
          const level4 = (data.data['primaryChapterListDetails']['level4'] || []).filter(obj => obj.IsSelect == true)
          allChap.push(...level4)

          //filterinh all sub chapters only checkbox
          var finalSubChap = allChap.filter(element => element.IsCheckbox == true)


          // Primary Chapter Stall Area
          const primaryChapterStallArea = data.data['primaryChapterHeaderDetails'][0].ExhibitionStallSizeID


          if (data.data['primaryChapterHeaderDetails'][0].SSIDocumentPath != null && data.data['primaryChapterHeaderDetails'][0].SSIDocumentPath != '') {
            var filePath = data.data['primaryChapterHeaderDetails'][0].SSIDocumentPath
            var array = data.data['primaryChapterHeaderDetails'][0].SSIDocumentPath != null &&
              data.data['primaryChapterHeaderDetails'][0].SSIDocumentPath != "" && filePath.split("/")
            const FileName = array[array.length - 1]
            this.setState({
              isSSifilePath: filePath,
              isSSifile: FileName,
              isSSIdeleted: false,
              isSSIreplaced: false,
            })
            console.log("here")
          }
          if (data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA_DocumentPath != null && data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA_DocumentPath != '') {
            var filePath = data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA_DocumentPath
            var array = data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA_DocumentPath != null &&
              data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA_DocumentPath != "" && filePath.split("/")
            const FileName = array[array.length - 1]
            this.setState({
              TMMAITAMMAfilePath: filePath,
              TMMAITAMMAfile: FileName,
              isTMMAITAMMAdeleted: false,
              isTAMMAITAMMAreplaced: false
            })
          }
          // data.data['primaryChapterHeaderDetails'].length > 0 ? data.data['primaryChapterHeaderDetails'] : '',
          console.log(data.data['primaryChapterHeaderDetails'][0].isDoubleStorey)
          this.setState({
            isDoubleStorey: data.data['primaryChapterHeaderDetails'][0].isDoubleStorey,
            oldisDoubleStorey: data.data['primaryChapterHeaderDetails'][0].isDoubleStorey,
            isSSi: data.data['primaryChapterHeaderDetails'][0].isSSICertified,
            oldisSSI: data.data['primaryChapterHeaderDetails'][0].isSSICertified,
            doubleStoreyArea: data.data['primaryChapterHeaderDetails'][0].DoubleStoreyArea,
            InternationalArea: data.data['primaryChapterHeaderDetails'][0].InternationalArea,
            oldInternationalArea: data.data['primaryChapterHeaderDetails'][0].InternationalArea,
            olddoubleStoreyArea: data.data['primaryChapterHeaderDetails'][0].DoubleStoreyArea,
            TMMAITAMMA: data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA != null ? data.data['primaryChapterHeaderDetails'][0].TMMA_ITAMMA == 'TMMA' ? 1 : 2 : '',
            // TMMAITAMMAfilePath: data.data[0].TMMA_ITAMMA_DocumentPath
          })
          // Fill List Calling ForDropDown

          this.getFillList(countryActionId, '', '', countryId, '', '');
          this.getFillList(stateActionId, '', '', countryId, '', '');
          this.getFillList(cityActionId, '', '', countryId, '', '');
          this.getFillList(pincodeActionId, '', '', countryId, '', '');


          // Split Phone Numbers and country Code 
          // Registration Mobile No
          var mob1 = data.data['registrationDetails'][0]['MobileNo']
          const parts = mob1.split("-");
          const regMob1Code = parts[0]
          const regMob1No = parts[1]
          // Registration Alternate Mobile No
          var mob2 = data.data['registrationDetails'][0]['AlternateMobileNo']
          const parts2 = mob2.split("-")
          const regMob2Code = parts2[0]
          const regMob2No = parts2[1]
          // Registration Telephone No
          var tel = data.data['registrationDetails'][0]['Telephone']
          var parts3 = tel.split("-")
          const regTelCode = parts3[0]
          const regTelNo = parts3[1]
          // Registration Telephone No 
          var tel1 = data.data['registrationDetails'][0]['Telephone1']
          const parts4 = tel1.split("-")
          const tel1Code = parts4[0]
          const tel1No = parts4[1]
          // Registration Owner Mobile No 
          var ownerMobile = data.data['registrationDetails'][0]['Mobile']
          const parts5 = ownerMobile.split("-")
          const ownerMobileCode = parts5[0]
          const ownerMobileNumber = parts5[1]
          // Invoice Mobile No
          var invMob = data.data['registrationDetails'][0]['InvMobileNo']
          const parts6 = invMob.split("-")
          const invMobCode = parts6[0]
          const invMobNo = parts6[1]
          // Invoice Alternate Mob No
          var invMob2 = data.data['registrationDetails'][0]['InvAlternateMobileNo']
          const parts7 = invMob2.split("-")
          const invMob2Code = parts7[0]
          const invMob2No = parts7[1]
          // Invoice TelePhone No 
          var invTel = data.data['registrationDetails'][0]['InvTelephone']
          const parts8 = invTel.split("-")
          const invTelCode = parts8[0]
          const invTelNo = parts8[1]
          // Invoice TelePhone 1 No 
          var invTel1 = data.data['registrationDetails'][0]['InvTelephone1']
          const parts9 = invTel1.split("-")
          const invTel1Code = parts9[0]
          const invTel1No = parts9[1]

          console.log(new Date().setHours(0, 0, 0, 0) > new Date(moment(data.data['registrationDetails'][0]['Installment2DueDate'], "DD-MM-YYYY").format("YYYY-MM-DD")).setHours(0, 0, 0, 0), '///////////////', data.data['registrationDetails'][0]['Installment2DueDate'], new Date().setHours(0, 0, 0, 0), new Date(moment(data.data['registrationDetails'][0]['Installment2DueDate'], "DD-MM-YYYY").format("YYYY-MM-DD")),)
          this.setState({
            dueDate: data.data['registrationDetails'][0]['Installment2DueDate'] != null && data.data['registrationDetails'][0]['Installment2DueDate'] != '' && data.data['registrationDetails'][0]['Installment2DueDate'] != undefined ? new Date(moment(data.data['registrationDetails'][0]['Installment2DueDate'], "DD-MM-YYYY").format("YYYY-MM-DD")) : ''
          })
          this.setState({
            forcedDisable: data.data['registrationDetails'][0]['IsErrorIdentified'] != null && data.data['registrationDetails'][0]['IsErrorIdentified'] != '' && data.data['registrationDetails'][0]['IsErrorIdentified'] != undefined ? data.data['registrationDetails'][0]['IsErrorIdentified'] : false
          })

          async function seqnoFormat(arr) {
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].seqno != '' && arr[i].seqno != null) {
                arr[i].ChapterName.trim()
                // console.log(arr[i].ChapterName)
                if (/^\d$/.test(arr[i].ChapterName[0])) {
                  for (var j = 0; j < arr[i].ChapterName.length; j++) {
                    if (arr[i].ChapterName[j] == ' ') {
                      var str = arr[i].ChapterName.slice(j)
                      var finalName = arr[i].seqno + str
                      arr[i].ChapterName = finalName
                      // console.log("primaryChapterListActionId 121212", i, finalName)
                      break
                    }
                  }
                } else {
                  var str = arr[i].ChapterName
                  var finalName = arr[i].seqno + ' ' + str
                  arr[i].ChapterName = finalName
                }
              }
            }
            return
          }
          for (var i = 0; i < data.data['primaryChapterListDetails']['primaryChapter'].length; i++) {
            for (var j = 0; j < data.data['primaryChapterListDetails']['primaryChapter'].length - 1 - i; j++) {
              var seq1 = data.data['primaryChapterListDetails']['primaryChapter'][j].seqno
              var seq2 = data.data['primaryChapterListDetails']['primaryChapter'][j + 1].seqno
              if ((parseFloat(seq1) > parseFloat(seq2))) {
                var temp = data.data['primaryChapterListDetails']['primaryChapter'][j]
                data.data['primaryChapterListDetails']['primaryChapter'][j] = data.data['primaryChapterListDetails']['primaryChapter'][j + 1]
                data.data['primaryChapterListDetails']['primaryChapter'][j + 1] = temp;
                // console.log(i, j, arr[j])
              }
            }
            if (data.data['primaryChapterListDetails']['primaryChapter'][i].seqno == null || data.data['primaryChapterListDetails']['primaryChapter'][i].seqno == undefined) {
              console.log(data.data['primaryChapterListDetails']['primaryChapter'][i].seqno, i)
            }
            // seqnoFormat(data.data['primaryChapterListDetails']['primaryChapter'])
          }
          for (var i = 0; i < data.data['primaryChapterListDetails']['level2'].length; i++) {
            for (var j = 0; j < data.data['primaryChapterListDetails']['level2'].length - 1 - i; j++) {
              var seq1 = data.data['primaryChapterListDetails']['level2'][j].seqno
              var seq2 = data.data['primaryChapterListDetails']['level2'][j + 1].seqno
              if ((parseFloat(seq1) > parseFloat(seq2))) {
                var temp = data.data['primaryChapterListDetails']['level2'][j]
                data.data['primaryChapterListDetails']['level2'][j] = data.data['primaryChapterListDetails']['level2'][j + 1]
                data.data['primaryChapterListDetails']['level2'][j + 1] = temp;
                // console.log(i, j, arr[j])
              }
            }
            if (data.data['primaryChapterListDetails']['level2'][i].seqno == null || data.data['primaryChapterListDetails']['level2'][i].seqno == undefined) {
              console.log(data.data['primaryChapterListDetails']['level2'][i].seqno, i)
            }
            seqnoFormat(data.data['primaryChapterListDetails']['level2'])
          }
          // console.log("prr", data.data['level2'])
          for (var i = 0; i < data.data['primaryChapterListDetails']['level3'].length; i++) {
            for (var j = 0; j < data.data['primaryChapterListDetails']['level3'].length - 1 - i; j++) {

              var seq1 = data.data['primaryChapterListDetails']['level3'][j].seqno
              seq1 = seq1 != null && seq1.replaceAll('.', '')
              var seq2 = data.data['primaryChapterListDetails']['level3'][j + 1].seqno
              seq2 = seq2 != null && seq2.replaceAll('.', '')

              if ((parseFloat(seq1) > parseFloat(seq2))) {
                var temp = data.data['primaryChapterListDetails']['level3'][j]
                data.data['primaryChapterListDetails']['level3'][j] = data.data['primaryChapterListDetails']['level3'][j + 1]
                data.data['primaryChapterListDetails']['level3'][j + 1] = temp;
              }
            }
            if (data.data['primaryChapterListDetails']['level3'][i].seqno == null || data.data['primaryChapterListDetails']['level3'][i].seqno == undefined) {
              console.log(data.data['primaryChapterListDetails']['level3'][i].seqno, i)
            }
            seqnoFormat(data.data['primaryChapterListDetails']['level3'])
          }
          for (var i = 0; i < data.data['primaryChapterListDetails']['level4'].length; i++) {
            for (var j = 0; j < data.data['primaryChapterListDetails']['level4'].length - 1 - i; j++) {
              var seq1 = data.data['primaryChapterListDetails']['level4'][j].seqno
              seq1 = seq1 != null && seq1.replaceAll('.', '')
              var seq2 = data.data['primaryChapterListDetails']['level4'][j + 1].seqno
              seq2 = seq2 != null && seq2.replaceAll('.', '')
              if ((parseFloat(seq1) > parseFloat(seq2))) {
                var temp = data.data['primaryChapterListDetails']['level4'][j]
                data.data['primaryChapterListDetails']['level4'][j] = data.data['primaryChapterListDetails']['level4'][j + 1]
                data.data['primaryChapterListDetails']['level4'][j + 1] = temp;
                // console.log(i, j, arr[j])
              }
            }
            if (data.data['primaryChapterListDetails']['level4'][i].seqno == null || data.data['primaryChapterListDetails']['level4'][i].seqno == undefined) {
              console.log(data.data['primaryChapterListDetails']['level4'][i].seqno, i)
            }
            seqnoFormat(data.data['primaryChapterListDetails']['level4'])
          }

          for (var i = 0; i < data.data['primaryChapterListDetails']['level2'].length; i++) {
            data.data['primaryChapterListDetails']['level2'][i].isHighlight = false;
          }

          var exhibitlist = []
          // console.log("level2 get", level2)
          data.data['primaryChapterListDetails']['level2'].length > 0 && data.data['primaryChapterListDetails']['level2'].map(level2Data => {
            level2Data.DocumentName = ''
            level2Data.DocumentType = ''
            level2Data.DocumentFile = ''
            level2Data.DocumentPath = ''
            level2Data.DocDeleted = true
            if (level2Data.IsSelect && level2Data.IsCheckbox) {
              // console.log("level2Data get", level2Data)
              var temppath = (level2Data.isMachine || level2Data.IsAccessory) ? level2Data.Document : ''
              var temparr = temppath != null &&
                temppath != "" ? temppath.split("/") : []
              var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
              level2Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
              level2Data.DocumentType = ''
              level2Data.DocumentFile = ''
              level2Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
              level2Data.DocDeleted = temppath != '' && temppath != null ? false : true
              level2Data.Area = parseFloat(level2Data.Length || 0) * parseFloat(level2Data.Breadth || 0)
              exhibitlist.push(level2Data)
            }
          })
          data.data['primaryChapterListDetails']['level3'].length > 0 && data.data['primaryChapterListDetails']['level3'].map(level3Data => {
            level3Data.DocumentName = ''
            level3Data.DocumentType = ''
            level3Data.DocumentFile = ''
            level3Data.DocumentPath = ''
            level3Data.DocDeleted = true
            if (level3Data.IsSelect && level3Data.IsCheckbox) {
              var temppath = (level3Data.isMachine || level3Data.IsAccessory) ? level3Data.Document : ''
              var temparr = temppath != null &&
                temppath != "" ? temppath.split("/") : []
              var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
              level3Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
              level3Data.DocumentType = ''
              level3Data.DocumentFile = ''
              level3Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
              level3Data.DocDeleted = temppath != '' && temppath != null ? false : true
              level3Data.Area = parseFloat(level3Data.Length || 0) * parseFloat(level3Data.Breadth || 0)
              exhibitlist.push(level3Data)
            }
          })
          data.data['primaryChapterListDetails']['level4'].length > 0 && data.data['primaryChapterListDetails']['level4'].map(level4Data => {
            level4Data.DocumentName = ''
            level4Data.DocumentType = ''
            level4Data.DocumentFile = ''
            level4Data.DocumentPath = ''
            level4Data.DocDeleted = true
            if (level4Data.IsSelect && level4Data.IsCheckbox) {
              var temppath = (level4Data.isMachine || level4Data.IsAccessory) ? level4Data.Document : ''
              var temparr = temppath != null &&
                temppath != "" ? temppath.split("/") : []
              var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
              level4Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
              level4Data.DocumentType = ''
              level4Data.DocumentFile = ''
              level4Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
              level4Data.DocDeleted = temppath != '' && temppath != null ? false : true
              level4Data.Area = parseFloat(level4Data.Length || 0) * parseFloat(level4Data.Breadth || 0)
              exhibitlist.push(level4Data)
            }
          })
          exhibitlist.sort((a, b) => (a.ChapterID > b.ChapterID) ? 1 : -1);
          data.data['primaryChapterListDetails']['level0'].length > 0 && data.data['primaryChapterListDetails']['level0'].map(level0Data => {
            level0Data.DocumentName = ''
            level0Data.DocumentType = ''
            level0Data.DocumentFile = ''
            level0Data.DocumentPath = ''
            level0Data.DocDeleted = true
            if (level0Data.IsSelect) {
              // console.log("level2Data get", level2Data)
              var temppath = (level0Data.isMachine || level0Data.IsAccessory) ? level0Data.Document : ''
              var temparr = temppath != null &&
                temppath != "" ? temppath.split("/") : []
              var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
              level0Data.DocumentName = temppath != '' && temppath != null ? tempName : ''
              level0Data.DocumentType = ''
              level0Data.DocumentFile = ''
              level0Data.DocumentPath = temppath != '' && temppath != null ? temppath : ''
              level0Data.DocDeleted = temppath != '' && temppath != null ? false : true
              level0Data.Area = parseFloat(level0Data.Length || 0) * parseFloat(level0Data.Breadth || 0)
              exhibitlist.push(level0Data)
            }
          })
          const totalArea = exhibitlist.reduce((sum, obj) => sum + obj.Area, 0)
          const filterArray = exhibitlist.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')

          var toKeepOpen = false
          var totalBare = 0
          var totalShell = 0
          exhibitlist.length > 0 && exhibitlist.map(item => {
            if (item.ManufacturerName == '' || item.ManufacturerName == null) {
              toKeepOpen = true
            }
            if (item.ManufacturingCountry == '' || item.ManufacturingCountry == null) {
              toKeepOpen = true
            }
            if (!item.isMachine && !item.isBrochure && !item.IsAccessory) {
              toKeepOpen = true
            }
            if (item.isMachine || item.IsAccessory) {
              if (item.Area == '' || item.Area == null || item.Area == 0) {
                toKeepOpen = true
              }
            }

            if (item.SinglePhasePower == '' || item.SinglePhasePower == null) {
              item.SinglePhasePower = 0
            }
            if (item.ThreePhasePower == '' || item.ThreePhasePower == null) {
              item.ThreePhasePower = 0
            }
            if (item.WaterConsumption == '' || item.WaterConsumption == null) {
              item.WaterConsumption = 0
            }
            if (item.InletQuantity == '' || item.InletQuantity == null) {
              item.InletQuantity = 0
            }
            if (item.OutletQuantity == '' || item.OutletQuantity == null) {
              item.OutletQuantity = 0
            }
            if (item.MaxCompressedAir == '' || item.MaxCompressedAir == null) {
              item.MaxCompressedAir = 0
            }
            item.errArr = []
            if (data.data['registrationDetails'][0]['CountryID'] != 91) {
              item.CalculatedArea = 0
              item.ShellScheme = ''
            }
            if (item.ShellScheme == 1) {
              totalBare = totalBare + item.CalculatedArea
            }
            if (item.ShellScheme == 2) {
              totalShell = totalShell + item.CalculatedArea
            }
          })
          console.log(toKeepOpen, exhibitlist, 'exhibitlistexhibitlistexhibitlistexhibitlistexhibitlistexhibitlistexhibitlist')
          var isAllBrochure = true
          if (filterArray.length > 0) {
            for (var i = 0; i < filterArray.length; i++) {
              if (filterArray[i].IsAccessory || filterArray[i].isMachine) {
                isAllBrochure = false
              }
            }
          }

          var checkboxArr = []
          var ExhibitDetailsNoteArr = []
          if (data.data['estimateNote'] != undefined) {
            this.setState({
              ExhibitDetailsNote: []
            }, () => {
              for (var i = 0; i < data.data['estimateNote'].length; i++) {
                if (data.data['estimateNote'][i].NoteType == 'Estimate Checkbox Note') {
                  var obj = {}
                  obj.label = data.data['estimateNote'][i].Description
                  obj.value = data.data['estimateNote'][i].ExhRegistrationNotesId
                  obj.checked = false
                  obj.ExhRegistrationNotesId = data.data['estimateNote'][i].ExhRegistrationNotesId
                  // if (JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName.toLowerCase().trim() != 'India ') {
                  // data.data['estimateNote'][i].ExhRegistrationNotesId == 1041 && checkboxArr.push(obj)
                  if (data.data['estimateNote'][i]['Description'].toLowerCase().includes('claims')) {
                    if (data.data['configurationDetails'][0]['isAgreeClaim']) {
                      checkboxArr.push(obj)
                    }
                  }
                  if (data.data['estimateNote'][i]['Description'].toLowerCase().includes('rules and regulation')) {
                    if (data.data['configurationDetails'][0]['isAgreeRule']) {
                      checkboxArr.push(obj)
                    }
                  }
                  if (data.data['estimateNote'][i]['Description'].toLowerCase().includes('manufactured')) {
                    if (data.data['configurationDetails'][0]['isAgreeMFG']) {
                      checkboxArr.push(obj)
                    }
                  }
                  // if (data.data['estimateNote'][i]['Description'].toLowerCase().includes('undertaking')) {
                  //     if (data.data['configurationDetails'][0]['isAgreeUndertaking']) {
                  //         checkboxArr.push(obj)
                  //     }
                  // }
                  if (data.data['estimateNote'][i]['Description'].toLowerCase().includes('email') && data.data['estimateNote'][i]['Description'].toLowerCase().includes('sms') && data.data['estimateNote'][i]['Description'].toLowerCase().includes('whatsapp')) {
                    if (data.data['configurationDetails'][0]['isAgreeConsent']) {
                      checkboxArr.push(obj)
                    }
                  }

                  this.setState({
                    isFlag1: data.data['configurationDetails'][0]['isAgreeClaim'],
                    isFlag3: data.data['configurationDetails'][0]['isAgreeMFG'],
                    isFlag4: data.data['configurationDetails'][0]['isAgreeRule'],
                    isFlag5: false,
                    isFlag6: data.data['configurationDetails'][0]['isAgreeConsent'],

                    // MFdeadline: data.data['configurationDetails'][0]['isAgreeConsent'],
                    MFdeadline: data.data['configurationDetails'][0]['ExhibitDetailsManualFormDeadlineDate'] != null && data.data['configurationDetails'][0]['ExhibitDetailsManualFormDeadlineDate'] != '' && data.data['configurationDetails'][0]['ExhibitDetailsManualFormDeadlineDate'] != undefined ? new Date(moment(data.data['configurationDetails'][0]['ExhibitDetailsManualFormDeadlineDate'], "DD-MM-YYYY").format("YYYY-MM-DD")) : ''

                  })

                  // }
                  // else {
                  //     checkboxArr.push(obj)
                  // }
                }
                if (data.data['estimateNote'][i].NoteType == 'exhibit details') {
                  ExhibitDetailsNoteArr.push(data.data['estimateNote'][i])
                }

              }
            })
            // else {
            // if (JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName.toLowerCase().trim() != 'India ') {
            //     checkboxArr.pop()
            //     checkboxArr.pop()
            // }

            // }
          }
          console.log('checkboxArr', checkboxArr)
          console.log("id1------------>", checkboxArr)
          for (var i = 0; i < checkboxArr.length; i++) {
            if (checkboxArr[i].label.includes('claims')) {
              checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeClaim'] != null ? data.data['descriptionDetails'][0]['Is_AgreeClaim'] : false
            }
            // if (checkboxArr[i].ExhRegistrationNotesId == 1041) {
            if (checkboxArr[i].label.includes('Rules and Regulation')) {
              checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeRules'] != null ? data.data['descriptionDetails'][0]['Is_AgreeRules'] : false
            }
            if (checkboxArr[i].label.includes('manufactured')) {
              checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeMFG'] != null ? data.data['descriptionDetails'][0]['Is_AgreeMFG'] : false
            }
            if (checkboxArr[i].label.includes('undertaking')) {
              checkboxArr[i].checked = data.data['descriptionDetails'][0]['isAgreeUndertaking'] != null ? data.data['descriptionDetails'][0]['isAgreeUndertaking'] : false
            }
            if (checkboxArr[i].label.toLowerCase().includes('email') && checkboxArr[i].label.toLowerCase().includes('sms') && checkboxArr[i].label.toLowerCase().includes('whatsapp')) {
              checkboxArr[i].checked = data.data['descriptionDetails'][0]['isAgreeConsent'] != null ? data.data['descriptionDetails'][0]['isAgreeConsent'] : false
            }
          }
          // for (var i = 0; i < checkboxArr.length; i++) {
          //     if (checkboxArr[i].ExhRegistrationNotesId == 18) {
          //         checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeClaim'] != null ? data.data['descriptionDetails'][0]['Is_AgreeClaim'] : false
          //     }
          //     if (checkboxArr[i].ExhRegistrationNotesId == 19) {
          //         checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeRules'] != null ? data.data['descriptionDetails'][0]['Is_AgreeRules'] : false
          //     }
          //     if (checkboxArr[i].ExhRegistrationNotesId == 20) {
          //         checkboxArr[i].checked = data.data['descriptionDetails'][0]['Is_AgreeMFG'] != null ? data.data['descriptionDetails'][0]['Is_AgreeMFG'] : false
          //     }
          //     if (checkboxArr[i].ExhRegistrationNotesId == 21) {
          //         checkboxArr[i].checked = data.data['descriptionDetails'][0]['isAgreeUndertaking'] != null ? data.data['descriptionDetails'][0]['isAgreeUndertaking'] : false
          //     }
          // }
          // estimateDetails: data.data['estimateDetails'].length > 0 ? data.data['estimateDetails'] : '',
          console.log(data.data['estimateDetails'], '/////////////////////////////////////////////')
          for (var i = 0; i < data.data['estimateDetails'].length; i++) {
            if (data.data['estimateDetails'][i].Description.includes("--")) {
              data.data['estimateDetails'][i].Description = data.data['estimateDetails'][i].Description.replace(/\n/g, ' ')
              data.data['estimateDetails'][i].Description = data.data['estimateDetails'][i].Description.replace(/--/g, '\n')
            }
          }
          var undertakingContent = []
          data.data['descriptionDetails'][0]['UndertakingContent1'] != null && data.data['descriptionDetails'][0]['UndertakingContent1'] != undefined && undertakingContent.push(data.data['descriptionDetails'][0]['UndertakingContent1'])
          data.data['descriptionDetails'][0]['UndertakingContent2'] != null && data.data['descriptionDetails'][0]['UndertakingContent2'] != undefined && undertakingContent.push(data.data['descriptionDetails'][0]['UndertakingContent2'])
          // data.data['descriptionDetails'][0]['UndertakingContent3'] != null && data.data['descriptionDetails'][0]['UndertakingContent3'] != undefined && undertakingContent.push(data.data['descriptionDetails'][0]['UndertakingContent3'])
          data.data['descriptionDetails'][0]['UndertakingContent5'] != null && data.data['descriptionDetails'][0]['UndertakingContent5'] != undefined && undertakingContent.push(data.data['descriptionDetails'][0]['UndertakingContent5'])
          data.data['descriptionDetails'][0]['UndertakingContent4'] != null && data.data['descriptionDetails'][0]['UndertakingContent4'] != undefined && undertakingContent.push(data.data['descriptionDetails'][0]['UndertakingContent4'])
          var multiSelectNotes = []
          // var exhibitDetailsNote = []
          for (var i = 0; i < data.data['estimateNote'].length; i++) {
            // if (data.data[1][i].NoteType == 'Guidelines') {
            //     guideLines.push(data.data[1][i])
            // }
            // if (data.data[1][i].NoteType == 'Chapter Notes') {
            //     notes.push(data.data[1][i])
            // }
            if (data.data['estimateNote'][i].NoteType == 'PrimaryChapter MultiSelect') {
              multiSelectNotes.push(data.data['estimateNote'][i])
            }
            // if (data.data[1][i].NoteType == 'exhibit details') {
            //     exhibitDetailsNote.push(data.data[1][i])
            // }
          }
          const selectedCompanyProfilesToBind = data.data['registrationDetails'][0]['ExhCompanyProfileIDs'] != null &&
            data.data['registrationDetails'][0]['ExhCompanyProfileIDs'] != ""
            ? [...new Set(
              data.data['registrationDetails'][0]['ExhCompanyProfileIDs']
                .toString()
                .split(",")
                .map((id) => Number(id.trim()))
                .filter((id) => !Number.isNaN(id))
            )]
            : (this.state.selectedCompanyProfiles || []);
          const otherCompanyProfileNameToBind = data.data['registrationDetails'][0]['OtherName'] != null &&
            data.data['registrationDetails'][0]['OtherName'] != ""
            ? data.data['registrationDetails'][0]['OtherName']
            : this.state.otherCompanyProfileName;
          console.log(selectedCompanyProfilesToBind, otherCompanyProfileNameToBind, "data.data['primaryChapterHeaderDetails']")
          var primaryChapterListTemp = data.data['registrationDetails'][0].PrimaryChapter != null ? typeof data.data['registrationDetails'][0].PrimaryChapter == 'string' ? data.data['registrationDetails'][0].PrimaryChapter.split(',') : [data.data['registrationDetails'][0].PrimaryChapter] : []
          if (primaryChapterListTemp.length > 0) {
            for (var i = 0; i < primaryChapterListTemp.length; i++) {
              primaryChapterListTemp[i] = typeof primaryChapterListTemp[i] == 'string' ? parseInt(primaryChapterListTemp[i].trim()) : primaryChapterListTemp[i]
            }
          }
          var mainPrimary = data.data['primaryChapterHeaderDetails'][0].PrimaryChapter != null ? data.data['primaryChapterHeaderDetails'][0].PrimaryChapter : ''
          if (selectedCompanyProfilesToBind.length == 0) {
            if (otherCompanyProfileNameToBind == '' || otherCompanyProfileNameToBind == null) {
              this.setState({ isEnableCP: true })
            }
          }
          console.log("finalSubChap-->", finalSubChap)
          this.setState({
            subChapters: finalSubChap,
            oldsubChapters: finalSubChap.length > 0 ? JSON.parse(JSON.stringify(finalSubChap)) : [],

          })
        } else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      }).catch((err) => {
        console.log(err)
      })
  }

  getStallPossession() {
    const { ExhRegistrationID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getStallPossession_action(ExhRegistrationID)
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            exhCompanyName: data.data[0][0]["Exhibitor Compnay Name"] || "",
            hallNo: data.data[0][0]["HallNo"] || "",
            stallNo: data.data[0][0]["StallNo"] || "",
            stallPossessionId: data.data[0][0]["StallPossessionID"] || "",
            countryId: data.data[0][0]["CountryID"] || "",
            personName: data.data[0][0]["PersonName"] || "",
            companyName: data.data[0][0]["CompanyName"] || "",
            contactNo: data.data[0][0]["ContactNo"] || "",
            email: data.data[0][0]["Email"] || "",
            isAgree: data.data[0][0]["IS_Agree"] || false,
            remark: data.data[0][0]["Remark"] || "",
            isLoading: false,
            ManualFormList: data.data[3] || []
          });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  tagDDSubmit(ExhStallPossessionVendorDDdetailsID, event, isSendMail) {
    const { vendorList, vendorListIndex } = this.state;
    this.setState({ isLoading: true });
    this.props
      .tagDDSubmit_action(ExhStallPossessionVendorDDdetailsID, event, isSendMail)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(event ? 'DD received tagged successfully' : 'DD not receive tagged successfully');
          // this.getStallPossessionChecklistDetails();
        } else {
          toastError(data.msg);
        }
        this.setState({ isLoading: false, isConfirm: false });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  preventMinus = (e) => {
    (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault();
    if (e.code === "Minus") {
      e.preventDefault();
    }
  };

  handlePaste = (event) => {
    const pastedValue = event.clipboardData.getData("text/plain");
    const sanitizedValue = pastedValue.replace(/[-.eE]/g, ""); // Remove '-', '.', 'e', 'E' characters

    // Replace the input value with the sanitized value
    document.execCommand("insertText", false, sanitizedValue);

    event.preventDefault(); // Prevent the default paste behavior
  };

  maxLengthCheck = (object, maxLength) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  // On Back Click
  onCancelClick() {
    this.props.navigate("/manualForms");
  }

  // Input Validate
  inputValidate() {
    const {
      personName,
      companyName,
      contactNo,
      email,
      ITMEStaffName,
      IssuedDate,
      exitPersonName,
      exitCompanyName,
      exitContactNo,
      exitEmail,
    } = this.state;
    if (personName == "" || personName == null) {
      this.setState({ personNameErr: "Please Enter Person Name" });
    }
    if (companyName == "" || companyName == null) {
      this.setState({ companyNameErr: "Please Enter Company Name" });
    }
    if (contactNo == "" || contactNo == null) {
      this.setState({ contactNoErr: "Please Enter Contact No." });
    }
    if (email == "" || email == null) {
      this.setState({ emailErr: "Please Enter Email" });
    }
    if (exitPersonName == "" || exitPersonName == null) {
      this.setState({ exitPersonNameErr: "Please Enter Person Name" });
    }
    if (exitCompanyName == "" || exitCompanyName == null) {
      this.setState({ exitCompanyNameErr: "Please Enter Company Name" });
    }
    if (exitContactNo == "" || exitContactNo == null) {
      this.setState({ exitContactNoErr: "Please Enter Contact No." });
    }
    if (exitEmail == "" || exitEmail == null) {
      this.setState({ exitEmailErr: "Please enter Email" });
    }
    if (ITMEStaffName == "" || ITMEStaffName == null) {
      this.setState({ ITMEStaffNameErr: "Please Enter ITME Staff Name" });
    }
    if (IssuedDate == null) {
      this.setState({ IssuedDateErr: "Please Select Issued Date" });
    }
    if (email != "") {
      var emailError = emailValidator(email);
      if (emailError != "") {
        this.setState({ emailErr: emailError });
        return;
      }
    }
  }

  checkDuplicates(array, keys) {
    const seen = new Set();
    const duplicates = [];

    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      const compositeKey = keys.map((k) => obj[k]).join("|");

      if (seen.has(compositeKey)) {
        duplicates.push({ index: i, values: compositeKey });
      } else {
        seen.add(compositeKey);
      }
    }

    if (duplicates.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  // On Submit
  onSubmit(IsNDCMarked) {
    IsNDCMarked && this.inputValidate();
    const {
      personName,
      companyName,
      contactNo,
      email,
      personNameErr,
      companyNameErr,
      contactNoErr,
      emailErr,
      isAgree,
      remark,
      ITMEStaffName,
      IssuedDate,
      checkList,
      ITMEStaffNameErr,
      IssuedDateErr,
      ExhRegistrationID,
      vendorList,
      exitPersonName,
      exitCompanyName,
      exitContactNo,
      exitEmail,
    } = this.state;
    console.log("vendorList------------------->", vendorList)
    if (
      IsNDCMarked ? (ITMEStaffName != "" &&
        IssuedDate != null &&
        personName != "" &&
        companyName != "" &&
        contactNo != "" &&
        email != "" &&
        exitPersonName != "" &&
        exitCompanyName != "" &&
        exitContactNo != "" &&
        exitEmail != "") : true
    ) {
      if (
        IsNDCMarked ? (ITMEStaffNameErr == "" &&
          IssuedDateErr == "" &&
          personNameErr == "" &&
          companyNameErr == "" &&
          contactNoErr == "" &&
          emailErr == "") : true
      ) {
        if (IsNDCMarked) {

          const emailValidate = emailValidator(email);
          if (emailValidate) {
            toastError(emailValidate);
            this.setState({ emailErr: emailValidate });
            return;
          }

          const mobileNoValidate = mobileNoValidator(contactNo);
          if (mobileNoValidate) {
            toastError(mobileNoValidate);
            this.setState({ contactNoErr: mobileNoValidate });
            return;
          }

          const emailValidate2 = emailValidator(exitEmail);
          if (emailValidate2) {
            toastError(emailValidate2);
            this.setState({ exitEmailErr: emailValidate2 });
            return;
          }

          const mobileNoValidate2 = mobileNoValidator(exitContactNo);
          if (mobileNoValidate2) {
            toastError(mobileNoValidate2);
            this.setState({ exitContactNoErr: mobileNoValidate2 });
            return;
          }
          const isValid = checkList.every((item) => item.IsChecked);
          if (!isValid) {
            return toastError("Please check all checklist item");
          }

          const isVendorValidate = vendorList.every((item) => item.isAddDD);
          if (!isVendorValidate) {
            this.setState({ iaMandatory: true });
            return toastError("Please add all vendor dd details");
          }
        }

        const array1 = [];
        const array2 = [];
        vendorList.filter(item => !item.isITMEVendor).forEach((item) => {
          array1.push({
            VendorID: item.VendorID || null,
            DD_Number: item.DD_Number || null,
            DD_Date: item.DD_Date ? moment(item.DD_Date).format("YYYY-MM-DD") : null,
            DD_Amount: item.DD_Amount || null,
            BankName: item.DD_BankName || null,
            DDSubmittedByCompanyName: item.DD_SubmitCompanyName || null,
            DDSubmittedByPersonName: item.DD_SubmitPersonName || null,
            DDSubmittedByEmaiID: item.DD_SubmitEmailId || null,
            DDSubmittedByMobileNo: item.DD_SubmitMobileNo || null,
            IsSameAsAbove: item.SameAsAbove || false,
            DDReturnByCompanyName: item.DD_ReturnCompanyName || null,
            DDReturnByPersonName: item.DD_ReturnPersonName || null,
            DDReturnByEmaiID: item.DD_ReturnEmailId || null,
            DDReturnByMobileNo: item.DD_ReturnMobileNo || null,
            DDReturnToCompanyName: item.DD_ReturnToCompanyName || null,
            DDReturnToPersonName: item.DD_ReturnToPersonName || null,
            DDReturnToEmaiID: item.DD_ReturnToEmaiID || null,
            DDReturnToMobileNo: item.DDReturnByMobileNo || null,
            FileName: item.FileName || null,
            FileType: item.FileType || null,
            FilePath: item.FilePath || null,
            DDFileName: item.DDFileName || null,
            DDFileType: item.DDFileType || null,
            DDFilePath: item.DDFilePath || null,
          });

          item.subContractorList.forEach((data) => {
            array2.push({
              VendorID: item.VendorID || null,
              SubcontractorCompanyName: data.CompanyName || null,
              SubcontractorPersonName: data.PersonName || null,
              SubcontractorEmailID: data.EmailId || null,
              SubcontractorMobileNo: data.MobileNo || null,
            });
          });
        });

        this.setState({ isLoading: true });
        this.props
          .insertStallPossession_action(
            ExhRegistrationID,
            personName,
            companyName,
            contactNo,
            email,
            isAgree,
            remark,
            1,
            array1,
            array2,
            null,
            null,
            {},
            exitPersonName,
            exitCompanyName,
            exitContactNo,
            exitEmail
          )
          .then((data) => {
            if (data.error != 1) {
              this.updateStallPossessionChecklist(IsNDCMarked);
              // this.setState({ isLoading: false });
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toastError("Please Enter Mandatory Fields");
      }
    } else {
      toastError("Please Enter Mandatory Fields");
    }
  }

  async getStallPossessionChecklistDetails() {
    const { exhibitionID, ExhRegistrationID } = this.state;

    this.setState({ isLoading: true });

    try {
      const data = await this.props.getExhStallPossessionDetails_action(
        exhibitionID,
        ExhRegistrationID
      );

      if (data.error === 1) {
        this.setState({ isLoading: false });
        toastError(data.msg);
        return;
      }

      // Basic Details
      const basicDetails = data.data?.[0]?.[0] || {};
      const checklist = data.data?.[1] || [];
      const vendorListData = data.data?.[2] || [];
      const ddDetails = data.data?.[3] || [];
      const subContractorList = data.data?.[4] || [];
      const hasNonEmpanelVendor = vendorListData.some(v => v.Empanel != 1);
      const updatedChecklist = (Array.isArray(checklist) ? checklist : [])
        .map(item => {
          let IsChecked = item.IsChecked;
          item.isDDApplicable = true;
          if (!basicDetails.IssuedDate) {
            if (item.ChecklistItem?.includes("Demand draft")) {
              IsChecked = basicDetails.isDDSubmitted;
              if (!item.Empanel && !hasNonEmpanelVendor) {
                item.IsChecked = true;
                item.isDDApplicable = false;
              }
            } else if (item.ChecklistItem?.includes("Exhibitor must clear all space rental")) {
              IsChecked = basicDetails.isFullPIPaid;
            } else if (item.ChecklistItem?.includes("Stall Design Approval")) {
              IsChecked = basicDetails.isStallDesignApprove;
            }


          }
          return {
            ...item,
            IsChecked
          };
        })
        .sort((a, b) => (a?.Seqno ?? 0) - (b?.Seqno ?? 0));


      this.setState({
        basicDetailsList: basicDetails,
        checkList: updatedChecklist,
        ITMEStaffName: basicDetails.ITMEStaffName || "",
        IssuedDate: basicDetails.IssuedDate
          ? moment(basicDetails.IssuedDate, "YYYY-MM-DD HH:mm").toDate()
          : new Date(),
        Remark: basicDetails.Remark || "",
        HallNo_StallNo: basicDetails["HallNo/StallNo"] || "",
        SignatureUUID: basicDetails["SignatureUUID"] || "",

        exitCompanyName: basicDetails.ExitCompanyName,
        exitPersonName: basicDetails.ExitPersonName,
        exitEmail: basicDetails.ExitEmailID,
        exitContactNo: basicDetails.ExitMobileNo,
        IsNDCIssued: basicDetails.IssuedDate ? true : false,
        IsAllChecked: updatedChecklist.every((item) => item.IsChecked),
      });
      // Build vendor array
      const vendorArray = vendorListData.map((vendor) => {
        const isEmpanel = vendor.Empanel == 1;

        // If DD details exist, match them to the vendor (if any)
        const ddInfo =
          ddDetails.find(
            (dd) =>
              dd.VendorID == vendor.VendorID ||
              dd.VendorID == vendor.NonEmpanelVendorID
          ) || {};

        console.log("ddInfo--->", ddInfo)
        return {
          VendorID: vendor.VendorID || vendor.NonEmpanelVendorID,
          PersonName: vendor.VendorName,
          CompanyName: vendor.VendorCompanyName,
          MobileNo: vendor.VendorMobile,
          EmailId: vendor.VendorEmail,
          Type: isEmpanel ? "Empanel" : "Non-Empanel",

          // DD details
          DD_Number: ddInfo.DD_Number || "",
          DD_Amount: ddInfo.DD_Amount || "",
          DD_Date: ddInfo.DD_Date
            ? moment(ddInfo.DD_Date, "YYYY-MM-DD").toDate()
            : null,
          DD_BankName: ddInfo.BankName || "",

          DD_NumberErr: "",
          DD_AmountErr: "",
          DD_DateErr: null,
          DD_BankNameErr: "",

          // DD Submit details
          DD_SubmitPersonName:
            ddInfo.DDSubmittedByPersonName || vendor.VendorName || "",
          DD_SubmitCompanyName:
            ddInfo.DDSubmittedByCompanyName || vendor.VendorCompanyName || "",
          DD_SubmitMobileNo:
            ddInfo.DDSubmittedByMobileNo || vendor.VendorMobile || "",
          DD_SubmitEmailId:
            ddInfo.DDSubmittedByEmaiID || vendor.VendorEmail || "",

          DD_SubmitPersonNameErr: "",
          DD_SubmitCompanyNameErr: "",
          DD_SubmitMobileNoErr: "",
          DD_SubmitEmailIdErr: "",

          // DD Return details
          DD_ReturnPersonName: ddInfo.DDReturnToPersonName || "",
          DD_ReturnCompanyName: ddInfo.DDReturnToCompanyName || "",
          DD_ReturnMobileNo: ddInfo.DDReturnToMobileNo || "",
          DD_ReturnEmailId: ddInfo.DDReturnToEmaiID || "",

          DD_ReturnPersonNameErr: "",
          DD_ReturnCompanyNameErr: "",
          DD_ReturnMobileNoErr: "",
          DD_ReturnEmailIdErr: "",

          FileName: ddInfo.DDReturnToPhotoID
            ? ddInfo.DDReturnToPhotoID.substring(
              ddInfo.DDReturnToPhotoID.lastIndexOf("/") + 1
            )
            : null,
          FilePath: ddInfo.DDReturnToPhotoID || null,
          FileType: null,
          FileNameErr: "",

          DDFileName: ddInfo.DDImage
            ? ddInfo.DDImage.split('/').pop()
            : null,
          DDFilePath: ddInfo.DDImage || null,
          DDFileType: null,
          DDFileNameErr: "",

          SameAsAbove: ddInfo.IsSameAsAbove || false,
          isITMEVendor: isEmpanel,
          subContractorList: subContractorList
            .filter(
              (item) =>
                item.VendorID == vendor.VendorID ||
                item.VendorID == vendor.NonEmpanelVendorID
            )
            .map((item) => ({
              VendorID: item.VendorID,
              CompanyName: item.SubContractorCompanyName,
              PersonName: item.SubContractorPersonName,
              MobileNo: item.SubContractorMobileNo,
              EmailId: item.SubcontractorEmailID,
            })),
          isAddDD: isEmpanel ? true : ddDetails.length > 0,
          ServiceName: vendor.ServiceName || "",
          IsDDSubmitted: ddInfo.IsDDSubmitted,
          ExhStallPossessionChecklistHdrID: ddInfo.ExhStallPossessionChecklistHdrID,
          ExhStallPossessionVendorDDdetailsID: ddInfo.ExhStallPossessionVendorDDdetailsID,
        };
      }).sort((a, b) => b.isITMEVendor - a.isITMEVendor);

      this.setState({ isLoading: false, vendorList: vendorArray });
    } catch (err) {
      this.setState({ isLoading: false });
      toastError(
        "Something went wrong while fetching stall possession details."
      );
    }
  }

  updateStallPossessionChecklist(IsNDCMarked) {
    const {
      exhibitionID,
      ExhRegistrationID,
      SignaturePath,
      checkList,
      basicDetailsList,
      ITMEStaffName,
      IssuedDate,
      Remark,
      vendorList,
      exitPersonName,
      exitCompanyName,
      exitContactNo,
      exitEmail,
      IsNDCIssued,
    } = this.state;
    const array1 = [];
    const array2 = [];
    vendorList.forEach((item) => {
      if (item.Type == "Non-Empanel") {
        array1.push({
          VendorID: item.VendorID || null,
          DD_Number: item.DD_Number || null,
          DD_Date: item.DD_Date
            ? moment(item.DD_Date).format("YYYY-MM-DD")
            : null,
          DD_Amount: item.DD_Amount || null,
          BankName: item.DD_BankName || null,
          DDSubmittedByCompanyName: item.DD_SubmitCompanyName || null,
          DDSubmittedByPersonName: item.DD_SubmitPersonName || null,
          DDSubmittedByEmaiID: item.DD_SubmitEmailId || null,
          DDSubmittedByMobileNo: item.DD_SubmitMobileNo || null,
          IsSameAsAbove: item.SameAsAbove || false,
          DDReturnByCompanyName: item.DD_ReturnCompanyName || null,
          DDReturnByPersonName: item.DD_ReturnPersonName || null,
          DDReturnByEmaiID: item.DD_ReturnEmailId || null,
          DDReturnByMobileNo: item.DD_ReturnMobileNo || null,
          DDReturnToCompanyName: item.DD_ReturnToCompanyName || null,
          DDReturnToPersonName: item.DD_ReturnToPersonName || null,
          DDReturnToEmaiID: item.DD_ReturnToEmaiID || null,
          DDReturnToMobileNo: item.DDReturnByMobileNo || null,
          FileName: item.FileName || null,
          FileType: item.FileType || null,
          FilePath: item.FilePath || null,
          IsDDSubmitted: item.IsDDSubmitted || false,
          DDFileName: item.DDFileName || null,
          DDFileType: item.DDFileType || null,
          DDFilePath: item.DDFilePath || null,
        });

        item.subContractorList.forEach((data) => {
          array2.push({
            VendorID: item.VendorID || null,
            SubcontractorCompanyName: data.CompanyName || null,
            SubcontractorPersonName: data.PersonName || null,
            SubcontractorEmailID: data.EmailId || null,
            SubcontractorMobileNo: data.MobileNo || null,
          });
        });
      }
    });

    const formatdate = IssuedDate
      ? moment(IssuedDate).format("YYYY-MM-DD HH:mm")
      : null;

    this.props
      .updateExhStallPossessionChecklist_action(
        exhibitionID,
        basicDetailsList.ExhRegistrationNo,
        ExhRegistrationID,
        ITMEStaffName,
        formatdate,
        Remark,
        checkList,
        exitPersonName,
        exitCompanyName,
        exitContactNo,
        exitEmail,
        array1,
        array2,
        IsNDCMarked
      )
      .then((data) => {
        if (data.error != 1) {
          if (IsNDCMarked) {
            this.setState({ isLoading: false });
            toastSuccess(
              IsNDCIssued
                ? "Stall possession updated successfully!"
                : "NDC issued marked successfully!"
            );
            if (!IsNDCIssued) {
              this.sendNoDues();
            }
            setTimeout(() => {
              window.history.back();
            }, 2000);
          } else {
            toastSuccess("DD details added successfully!")
            // this.getStallPossessionChecklistDetails()
            this.setState({ isLoading: false });
          }

        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  viewNoDues() {
    const { exhibitionID, ExhRegistrationID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .download_no_due_action(exhibitionID, ExhRegistrationID)
      .then((data) => {
        if (data.error != 1) {
          console.log("jjjjjjjjjjjjjjj", data);
          var url = `${downloadReport}?SessionIdentifier=${data}`;
          const win = window.open(url, "_blank");

          if (win) {
            win.focus();
          }

          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });

          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          if (actionID === exhibitionActionId) {
            this.setState({
              exhibitionList: data.data,
            });
          }
        }
        this.setState({ isLoading: false });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleCheck = (category, item) => {
    const newData = this.state.checkList.map((d) => {
      if (d.Category === category && d.ChecklistItem === item) {
        console.log("d.IsDDshow--------------->", d.IsDDshow);
        if (d.IsDDshow && !d.IsChecked) {
          this.setState({ isVendorDDView: true });
        } else if (d.IsDDshow) {
          this.setState({ isVendorDDView: false });
        }
        return { ...d, IsChecked: !d.IsChecked };
      }
      return d;
    });

    this.setState({
      checkList: newData,
      IsAllChecked: newData.every((item) => item.IsChecked),
    });
  };

  groupByCategory = () => {
    return this.state.checkList.reduce((acc, item) => {
      acc[item.Category] = acc[item.Category] || [];
      acc[item.Category].push(item);
      return acc;
    }, {});
  };

  SignatureRef = React.createRef();
  clearOppSignature = () => {
    this.SignatureRef.current.clear();
    this.setState({
      IsSignatureSaved: false,
    });
  };
  clearOppSaveSignatureImg = () => {
    this.setState({
      SignaturePath: "",
      IsSignatureSaved: false,
      SignatureSaveFlag: false,
    });
  };
  saveOppSignature = () => {
    const SignaturePath = this.SignatureRef.current.toDataURL();

    if (this.SignatureRef.current.isEmpty() == false) {
      this.setState({
        SignaturePath: SignaturePath,
        IsSignatureSaved: true,
        SignatureSaveFlag: true,
      });
    } else {
      toastError("Please add signature!");
    }
  };

  handleCancel() {
    const {
      exhibitionID,
      CompanyName,
      RegistrationNO,
      hallId,
      stallId,
      Status,
    } = this.state;
    this.props.navigate("/stallPossessionChecklistList", {
      state: {
        ExhibitionID: exhibitionID,
        CompanyName: CompanyName,
        RegistrationNO: RegistrationNO,
        hallId: hallId,
        stallId: stallId,
        Status: Status,
      },
    });
  }

  // On Send No Dues
  sendNoDues() {
    const { ExhRegistrationID, SignatureUUID } = this.state;
    var list = [
      {
        ExhregistrationID: parseInt(ExhRegistrationID),
        hallStall: SignatureUUID,
      },
    ];
    this.setState({ isLoading: true });
    this.props
      .sendNoDues_action(list)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess("No Dues Send Successfully");
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleInput = async (e, type, field, parentIndex, childIndex = null, ExhStallPossessionVendorDDdetailsID) => {
    console.log("call------------->",)
    const updatedList = structuredClone(this.state.vendorList); // deep clone
    let Value;

    // Determine the input value
    if (type === "date") {
      Value = e.target?.value || e; // handle both cases
    } else if (type === "int") {
      Value = e.target.value.replace(/\D/g, "");
    } else if (type === "checkbox") {
      Value = e.target.checked;
    } else if (type === "file") {
      Value = e.target.files;
    } else {
      Value = e.target.value;
    }

    if (field == 'IsDDSubmitted') {
      if (e.target.checked) {
        this.setState({ isConfirm: true, ExhStallPossessionVendorDDdetailsID: ExhStallPossessionVendorDDdetailsID, vendorListIndex: parentIndex })
      } else {
        this.tagDDSubmit(ExhStallPossessionVendorDDdetailsID, Value, false)
      }
    }

    const errorField = `${field}Err`;

    if (childIndex !== null) {
      // --- Subcontractor level update ---
      updatedList[parentIndex].subContractorList[childIndex][field] = Value;

      if (
        updatedList[parentIndex].subContractorList[childIndex][errorField] !==
        undefined &&
        Value !== ""
      ) {
        updatedList[parentIndex].subContractorList[childIndex][errorField] = "";
      }
    } else {
      // --- Parent-level update ---
      updatedList[parentIndex][field] = Value;

      const vendor = updatedList[parentIndex];
      if (field == 'IsDDSubmitted') {
        vendor.IsDDSubmitted = e.target.checked
      }
      // Apply "SameAsAbove" only when toggled on
      if (field === "SameAsAbove") {
        if (Value) {
          vendor.DD_ReturnPersonName = vendor.DD_SubmitPersonName;
          vendor.DD_ReturnCompanyName = vendor.DD_SubmitCompanyName;
          vendor.DD_ReturnMobileNo = vendor.DD_SubmitMobileNo;
          vendor.DD_ReturnEmailId = vendor.DD_SubmitEmailId;
        } else {
          vendor.DD_ReturnPersonName = "";
          vendor.DD_ReturnCompanyName = "";
          vendor.DD_ReturnMobileNo = "";
          vendor.DD_ReturnEmailId = "";
        }
        vendor.DD_ReturnPersonNameErr = "";
        vendor.DD_ReturnCompanyNameErr = "";
        vendor.DD_ReturnMobileNoErr = "";
        vendor.DD_ReturnEmailIdErr = "";
      }

      if (field === "Document") {
        const fileData = await this.onFilePick(e, Value);
        vendor.FileName = fileData.FileName;
        vendor.FilePath = fileData.FilePath;
        vendor.FileType = fileData.FileType;
        vendor.FileNameErr = "";
      }

      if (field === "DDDocument") {
        const fileData = await this.onFilePick2(e, Value);
        vendor.DDFileName = fileData.DDFileName;
        vendor.DDFilePath = fileData.DDFilePath;
        vendor.DDFileType = fileData.DDFileType;
        vendor.DDFileNameErr = "";
      }


      if (updatedList[parentIndex][errorField] !== undefined && Value !== "") {
        updatedList[parentIndex][errorField] = "";
      }
    }
    // Always update state after modification
    this.setState({ vendorList: updatedList });
  };

  handleDelete = (parentIndex, childIndex) => {
    const updatedList = [...this.state.vendorList];
    updatedList[parentIndex].subContractorList = updatedList[
      parentIndex
    ].subContractorList.filter((_, i) => i !== childIndex);
    this.setState({ vendorList: updatedList });
  };

  onSaveModal = () => {
    const { vendorList, vendorIndex } = this.state;
    const vendor = vendorList[vendorIndex];

    let isValid = true;
    let errors = {};
    let toastMessage = ""; // track one toast message

    // --- Validate main mandatory DD fields ---
    const mandatoryFields = [
      { key: "DD_Number", label: "DD Number" },
      { key: "DD_Amount", label: "DD Amount" },
      { key: "DD_Date", label: "DD Date", isDate: true },
      { key: "DD_BankName", label: "Bank Name" },
      { key: "DD_SubmitCompanyName", label: "Company Name" },
      { key: "DD_SubmitPersonName", label: "Person Name" },
      { key: "DD_SubmitMobileNo", label: "Mobile No." },
      { key: "DD_SubmitEmailId", label: "Email Id." },
      { key: "DD_ReturnCompanyName", label: "Company Name" },
      { key: "DD_ReturnPersonName", label: "Person Name" },
      { key: "DD_ReturnMobileNo", label: "Mobile No." },
      { key: "DD_ReturnEmailId", label: "Email Id." },
      { key: "FileName", label: "Documents" },
      { key: "DDFileName", label: "Documents" },
    ];

    let hasMandatoryError = false;
    for (let field of mandatoryFields) {
      const value = vendor[field.key];
      const isEmpty = field.isDate
        ? !value
        : value === null ||
        value === undefined ||
        (typeof value === "string" && !value.trim());

      console.log("isEmpty--->", isEmpty);
      if (isEmpty) {
        errors[`${field.key}Err`] = `Please ${field.label == "Documents" ? 'select' : 'enter'} ${field.label}`;
        hasMandatoryError = true;
        isValid = false;
      }
    }

    if (hasMandatoryError) {
      toastMessage = "Please enter mandatory fields"; // highest priority
    }

    // --- Validate subContractorList mandatory rows ---
    if (
      !hasMandatoryError &&
      vendor.subContractorList &&
      vendor.subContractorList.length > 0
    ) {
      const hasEmptySubRows = vendor.subContractorList.some(
        (sub) =>
          !sub.PersonName ||
          !sub.PersonName.trim() ||
          !sub.CompanyName ||
          !sub.CompanyName.trim() ||
          !sub.MobileNo ||
          !sub.MobileNo.trim() ||
          !sub.EmailId ||
          !sub.EmailId.trim()
      );

      if (hasEmptySubRows) {
        toastMessage = "Please fill all rows in the sub-contractor table!";
        isValid = false;
      }
    }

    const checkDuplicate = this.checkDuplicates(vendor.subContractorList, [
      "PersonName",
      "CompanyName",
      "MobileNo",
      "EmailId",
    ]);
    if (checkDuplicate) {
      toastMessage =
        "Duplicate records cannot be insert in the sub-contractor table!";
      isValid = false;
    }

    // --- Validate emails only if no mandatory or sub-contractor row errors ---
    if (!hasMandatoryError && !toastMessage) {
      const submitEmailError = emailValidator(
        vendor.DD_SubmitEmailId?.trim() || ""
      );
      if (submitEmailError) {
        errors.DD_SubmitEmailIdErr = submitEmailError;
        isValid = false;
        toastMessage = submitEmailError;
      }

      const submitMobileError = mobileNoValidator(
        vendor.DD_SubmitMobileNo?.trim() || ""
      );
      if (submitMobileError) {
        errors.DD_SubmitMobileNoErr = submitMobileError;
        isValid = false;
        toastMessage = submitMobileError;
      }

      const returnEmailError = emailValidator(
        vendor.DD_ReturnEmailId?.trim() || ""
      );
      if (returnEmailError) {
        errors.DD_ReturnEmailIdErr = returnEmailError;
        isValid = false;
        if (!toastMessage) toastMessage = returnEmailError;
      }

      const returnMobileError = mobileNoValidator(
        vendor.DD_ReturnMobileNo?.trim() || ""
      );
      if (returnMobileError) {
        errors.DD_ReturnMobileNoErr = returnMobileError;
        isValid = false;
        toastMessage = returnMobileError;
      }

      // --- Sub-contractor email validation ---
      if (vendor.subContractorList && vendor.subContractorList.length > 0) {
        const hasInvalidEmail = vendor.subContractorList.some((sub) => {
          const emailErr = emailValidator(sub.EmailId?.trim() || "");
          return emailErr !== "";
        });

        if (hasInvalidEmail && !toastMessage) {
          toastMessage =
            "Please enter valid email addresses in sub-contractors!";
          isValid = false;
        }

        const hasInvalidMobile = vendor.subContractorList.some((sub) => {
          const MobileNoErr = mobileNoValidator(sub.MobileNo?.trim() || "");
          return MobileNoErr !== "";
        });

        if (hasInvalidMobile && !toastMessage) {
          toastMessage = "Please enter valid contact no in sub-contractors!";
          isValid = false;
        }
      }
    }

    // --- Handle Validation Failures ---
    if (!isValid) {
      toastError(toastMessage); // only one toast

      this.setState((prevState) => {
        const updatedList = [...prevState.vendorList];
        updatedList[vendorIndex] = { ...vendor, ...errors };
        return { vendorList: updatedList };
      });
    } else {
      // --- Save Valid Data ---
      this.setState((prevState) => {
        const updatedList = [...prevState.vendorList];
        updatedList[vendorIndex] = { ...vendor, isAddDD: true };
        return {
          vendorList: updatedList,
          isOpen: !vendor.isAddDD,
          vendorIndex: !vendor.isAddDD ? this.state.vendorIndex : null,
          previousVendorData: null,
        };
      }, () => !vendor.isAddDD && this.onSubmit(false));
    }

    return isValid;
  };

  handleModalCancel = () => {
    const { vendorIndex, previousVendorData, vendorList } = this.state;

    if (previousVendorData && vendorIndex !== null) {
      // const restored = [...vendorList];
      // restored[vendorIndex] = JSON.parse(JSON.stringify(previousVendorData));
      this.setState({
        // vendorList: restored,
        isOpen: false,
        vendorIndex: null,
        previousVendorData: null,
      });
    } else {
      this.setState({ isOpen: false });
    }
  };

  openModal = (index) => {
    const vendor = this.state.vendorList[index];
    if (!vendor || Array.isArray(vendor)) {
      console.warn("⚠️ Invalid vendor data at index", index, vendor);
      return;
    }

    const backup = JSON.parse(JSON.stringify(vendor));
    this.setState({
      isOpen: true,
      vendorIndex: index,
      previousVendorData: backup,
    });
  };

  onFilePick = async (e, file) => {
    e.preventDefault();
    console.log("file--->", file);
    const { childList, allowedFileTypes } = this.state;
    if (file[0]["size"] > 5242880) {
      toast.error("File size more than 5mb are not allow.", {
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      // Clear the file input field
      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = ""; // Clear the input value
      }

      return;
    } else {
      var image = "";
      if (
        file[0]["name"].toString().toLowerCase().includes(".pdf") ||
        file[0]["name"].toString().toLowerCase().includes(".jpeg") ||
        file[0]["name"].toString().toLowerCase().includes(".png") ||
        file[0]["name"].toString().toLowerCase().includes(".jpg")
      ) {
        image = await this.convertToBase64(file[0]);

        return {
          FilePath: image,
          FileName: file[0]["name"],
          FileType: file[0]["name"].split(".")[1],
        };
      } else {
        toast.error(
          `Allowed File types .jpg,.jpeg,.png,.pdf with maximum size 5 MB`,
          {
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          }
        );
        // Clear the file input field
        document.getElementById("inputGroupFile").value = "";

        return;
      }
    }
  };

  onFilePick2 = async (e, file) => {
    e.preventDefault();
    console.log("file--->", file);
    const { childList, allowedFileTypes } = this.state;
    if (file[0]["size"] > 5242880) {
      toast.error("File size more than 5mb are not allow.", {
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      // Clear the file input field
      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = ""; // Clear the input value
      }

      return;
    } else {
      var image = "";
      if (
        file[0]["name"].toString().toLowerCase().includes(".jpeg") ||
        file[0]["name"].toString().toLowerCase().includes(".png") ||
        file[0]["name"].toString().toLowerCase().includes(".jpg")
      ) {
        image = await this.convertToBase64(file[0]);

        return {
          DDFilePath: image,
          DDFileName: file[0]["name"],
          DDFileType: file[0]["name"].split(".")[1],
        };
      } else {
        toast.error(`Allowed File types .jpg,.jpeg,.png with maximum size 5 MB`, {
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
        // Clear the file input field
        document.getElementById("inputGroupFile").value = "";

        return;
      }
    }
  };

  convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  handleViewFile = (base64String, fileName) => {
    // Extract MIME type and Base64 data
    const mimeType = base64String.split(";")[0].split(":")[1]; // Extract MIME type (e.g., 'image/png' or 'application/pdf')
    const byteCharacters = atob(base64String.split(",")[1]); // Extract Base64 content
    const byteNumbers = Array.from(byteCharacters).map((char) =>
      char.charCodeAt(0)
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    // Create a URL for the Blob
    const fileURL = URL.createObjectURL(blob);

    if (mimeType.startsWith("image/") || mimeType === "application/pdf") {
      // Open viewable files directly
      const newTab = window.open(fileURL, "_blank", "noopener,noreferrer");
      if (newTab) {
        newTab.document.title = fileName; // Set the tab title to the file name
      }
    } else {
      // Download non-viewable files
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName; // Use the specific file name for the download
      link.click();
    }

    // Clean up the blob URL after the file action
    setTimeout(() => URL.revokeObjectURL(fileURL), 500);
  };

  handleRemoveFile = (index) => {
    this.setState((prevState) => {
      const updatedList = [...prevState.vendorList];
      updatedList[index] = {
        ...updatedList[index],
        FileName: null,
        FileType: null,
        FilePath: null,
      };
      return { vendorList: updatedList };
    });
  };

  handleRemoveFile2 = (index) => {
    this.setState((prevState) => {
      const updatedList = [...prevState.vendorList];
      updatedList[index] = {
        ...updatedList[index],
        DDFileName: null,
        DDFileType: null,
        DDFilePath: null,
      };
      return { vendorList: updatedList };
    });
  };

  handleOpenModal = (index) => {
    this.setState({ isImageModal: true, VendorIndex: index });
  };

  handleCloseModal = () => {
    this.setState({ isImageModal: false });
  };

  handleOpenModal2 = (index) => {
    this.setState({ isImageModal2: true, VendorIndex: index });
  };

  handleCloseModal2 = () => {
    this.setState({ isImageModal2: false });
  };

  handleCapture = (imageData) => {
    const { VendorIndex } = this.state;
    this.setState((prevState) => {
      const updatedList = [...prevState.vendorList];
      updatedList[VendorIndex] = {
        ...updatedList[VendorIndex],
        FileName: "Document",
        FileType: "jpeg",
        FilePath: imageData,
        FileNameErr: "",
      };
      return { vendorList: updatedList };
    });
    this.setState({ isImageModal: false });
  };

  handleCapture2 = (imageData) => {
    const { VendorIndex } = this.state;
    this.setState((prevState) => {
      const updatedList = [...prevState.vendorList];
      updatedList[VendorIndex] = {
        ...updatedList[VendorIndex],
        DDFileName: "DDDocument",
        DDFileType: "jpeg",
        DDFilePath: imageData,
        DDFileNameErr: "",
      };
      return { vendorList: updatedList };
    });
    this.setState({ isImageModal2: false });
  };

  handleIsAllChecked(e) {
    const event = e.target.checked;
    this.setState({ IsAllChecked: event });
    const newData = this.state.checkList.map((d) => {
      return { ...d, IsChecked: !d.isDDApplicable ? true : event };
    });
    this.setState({ checkList: newData });
  }

  render() {
    const {
      isLoading,
      exhibitionID,
      exhibitionList,
      basicDetailsList,
      SignaturePath,
      IsSignatureSaved,
      SignatureSaveFlag,
      ITMEStaffName,
      IssuedDate,
      Remark,
      exhCompanyName,
      hallNo,
      stallNo,
      companyName,
      personName,
      contactNo,
      email,
      isAgree,
      remark,
      personNameErr,
      companyNameErr,
      countryId,
      contactNoErr,
      emailErr,
      currentDate,
      Status,
      ITMEStaffNameErr,
      IssuedDateErr,
      checkList,
      isOpen,
      vendorIndex,
      vendorList,
      iaMandatory,
      exitPersonName,
      exitCompanyName,
      exitContactNo,
      exitEmail,
      exitPersonNameErr,
      exitCompanyNameErr,
      exitContactNoErr,
      exitEmailErr,
      isVendorDDView,
      isImageModal,
      isImageModal2,
      IsNDCIssued,
      IsAllChecked,
      isConfirm,
      ManualFormList,
      subChapters,
      forcedDisable,
      forcedTempDisable,
      MFdeadline,
      PowerFormStatusID,
      waterFormStatusID,
      AirFormStatusID
    } = this.state;


    const grouped = this.groupByCategory();
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <div
          className={
            JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
              ? "with-dr-container"
              : "with-dr-container com-height"
          }
        >
          <div className="row">
            <div className="breadcrumb-scroll-fixed">
              <h6 className="mb-0 px-2 py-2 text-white">
                Stall Possession Checklist Update
              </h6>
            </div>
          </div>
          <div className="main-content admin-top-space">
            <AdminDrawer />
          </div>
          <div class="container-fluid">
            <div className="row">
              <div className="container mt-3">
                <div className="card shadow-none border rounded-3 p-0">
                  <div
                    className="card shadow-none rounded-3 mb-0 border-0">
                    <div
                      className="card-header  text-dark py-2 bg-card-header">
                      Exhibitor's Details
                    </div>
                    <div className="card-body d-flex flex-wrap gap-4 py-3 px-2">
                      <div>
                        <span className="fw-normal text-muted">
                          Registration No:
                        </span>{" "}
                        {basicDetailsList.ExhRegistrationNo || "-"}
                      </div>
                      <div>
                        <span className="fw-normal text-muted">Company:</span>{" "}
                        {basicDetailsList.ExhibitorCompanyName || "-"}
                      </div>
                      <div>
                        <span className="fw-normal text-muted">Country:</span>{" "}
                        {basicDetailsList.CountryName || "-"}
                      </div>
                      <div>
                        <span className="fw-normal text-muted">Hall No:</span>{" "}
                        {basicDetailsList.HallName || "-"}
                      </div>
                      <div>
                        <span className="fw-normal text-muted">Booth No:</span>{" "}
                        {basicDetailsList.StallName || "-"}
                      </div>
                      <div>
                        <span className="fw-normal text-muted">Booth Type:</span>{" "}
                        {basicDetailsList.StallTypeName || "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card shadow-none border rounded-3 p-0">
              <div
                className="card-header  text-dark py-2 bg-card-header">
                Representative for Stall Possession
              </div>
              <div class="card-body row pt-3 m-0 border">
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Person Name<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={personName}
                    maxLength={100}
                    onChange={(e) =>
                      this.setState({
                        personName: e.target.value.replace(/[^a-zA-Z ]/g, ""),
                        personNameErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {personNameErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Company Name<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={companyName}
                    maxLength={200}
                    onChange={(e) =>
                      this.setState({
                        companyName: e.target.value,
                        companyNameErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {companyNameErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Contact No<span className="text-red">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={contactNo}
                    // maxLength={countryId == 91 ? 10 : 20}
                    maxLength={10}
                    // onInput={(e) => this.maxLengthCheck(e, countryId == 91 ? 10 : 20)}
                    onInput={(e) => this.maxLengthCheck(e, 20)}
                    onKeyDown={(e) => this.preventMinus(e)}
                    onWheel={(e) => e.target.blur()}
                    onPaste={(e) => this.handlePaste(e)}
                    onChange={(e) =>
                      this.setState({
                        contactNo: e.target.value.replace(/\D/g, ""),
                        contactNoErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {contactNoErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Email ID<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={email}
                    maxLength={100}
                    onChange={(e) =>
                      this.setState({ email: e.target.value, emailErr: "" })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {emailErr}
                    </span>
                  }
                </div>
                {/* <div className="col-md-4">
                                <fieldset className="d-flex mt-3 mb-4">
                                    <button
                                        className="btn rounded-0 btn-primary"
                                        style={{ padding: "3px 7px", marginRight: 10 }}
                                        disabled={currentDate > DeadlineDate}
                                        onClick={(e) => this.onSubmit()}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        className="btn rounded-0 btn-dark"
                                        style={{ padding: "3px 7px" }}
                                        onClick={(e) => this.onCancelClick(e)}
                                    >
                                        Back
                                    </button>
                                </fieldset>
                            </div> */}
              </div>
            </div>

            <div className="card shadow-none border rounded-3 p-0">
              <div
                className="card-header  text-dark py-2 bg-card-header">
                Representative for Exit
              </div>
              <div class="card-body row pt-3">
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Person Name<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={exitPersonName}
                    maxLength={100}
                    onChange={(e) =>
                      this.setState({
                        exitPersonName: e.target.value.replace(
                          /[^a-zA-Z ]/g,
                          ""
                        ),
                        exitPersonNameErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {exitPersonNameErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Company Name<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={exitCompanyName}
                    maxLength={200}
                    onChange={(e) =>
                      this.setState({
                        exitCompanyName: e.target.value,
                        exitCompanyNameErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {exitCompanyNameErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Contact No<span className="text-red">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={exitContactNo}
                    // maxLength={countryId == 91 ? 10 : 20}
                    maxLength={10}
                    // onInput={(e) => this.maxLengthCheck(e, countryId == 91 ? 10 : 20)}
                    onInput={(e) => this.maxLengthCheck(e, 20)}
                    onKeyDown={(e) => this.preventMinus(e)}
                    onWheel={(e) => e.target.blur()}
                    onPaste={(e) => this.handlePaste(e)}
                    onChange={(e) =>
                      this.setState({
                        exitContactNo: e.target.value.replace(/\D/g, ""),
                        exitContactNoErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {exitContactNoErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Email ID<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={exitEmail}
                    maxLength={100}
                    onChange={(e) =>
                      this.setState({
                        exitEmail: e.target.value,
                        exitEmailErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {exitEmailErr}
                    </span>
                  }
                </div>
              </div>
            </div>

            <div className="card shadow-none border rounded-3 p-0">
              <div
                className="card-header  text-dark py-2 bg-card-header">
                Exhibitor Mandatory Form Status
              </div>
              <div class="card-body row pt-3 text-left">
                <ol className="px-4">
                  {ManualFormList.length > 0 ?
                    <>
                      {ManualFormList.map((item, i) => (
                        item.FormDisplayName != 'EXHIBITOR BADGES' && item.FormDisplayName != 'INVITATION LETTER FOR VISA APPLICATION' && item.FormDisplayName != 'E-DIRECTORY' ?
                          <li>{normalizeMessage(item.FormDisplayName)} <span className="text-aqua">({item.FormStatus})</span></li> :
                          <li>{normalizeMessage(item.FormDisplayName)} <span className="text-aqua">(Applied : {item.Applied}, Approved : {item.Approved}, Reject : {item.Reject})</span></li>
                      ))}
                      <li>Exhibit Details <span className="text-aqua" style={{ cursor: 'pointer' }} onClick={() => this.setState({ isExhibitPop: true })}>(<i className="fa fa-eye"></i> View</span>)</li>
                    </>
                    :
                    <li>Record not found</li>
                  }
                </ol>
              </div>
            </div>

            <div class="row m-0">
              <table class="table align-middle">
                <thead style={{ background: "#f2f2f2" }}>
                  <tr>
                    <th style={{ width: "250px" }}>Category</th>
                    <th>Checklist Item</th>
                    <th style={{ width: "100px" }} className="text-center">
                      <input
                        type="checkbox"
                        className="mt-2"
                        checked={IsAllChecked}
                        disabled={IsNDCIssued}
                        onChange={(e) => this.handleIsAllChecked(e)}
                      />
                      Status (
                      {checkList.filter((item) => item.IsChecked && item.isDDApplicable).length}/
                      {checkList.filter((item) => item.isDDApplicable).length})
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(grouped).map((category) =>
                    grouped[category].map((item, index) => (
                      <tr key={category + index}>
                        {/* Show category name only for first row of each group */}
                        {index === 0 ? (
                          <td
                            rowSpan={grouped[category].length}
                            className="p-2 border font-semibold"
                          >
                            {category}
                          </td>
                        ) : null}
                        <td className="p-2 border wrap-break-td">
                          {item.ChecklistItem}
                        </td>
                        <td className="p-2 border text-center">
                          {item.isDDApplicable ?
                            <input
                              type="checkbox"
                              checked={item.IsChecked}
                              disabled={IsNDCIssued}
                              onChange={() =>
                                this.handleCheck(category, item.ChecklistItem)
                              }
                            /> :
                            'N.A'
                          }
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              {/* {isVendorDDView && vendorList.length > 0 ? ( */}
              {vendorList.length > 0 ? (
                <div
                  className="row g-3"
                  style={{ maxHeight: 500, overflowY: "auto" }}
                >
                  {vendorList.map((item, i) =>
                    item.isITMEVendor ? (
                      <div className="col-md-3 col-sm-4">
                        <div className="card border-0 rounded-3 shadow-sm bg-light">
                          <div className="card-body p-2 pb-4 d-flex align-items-start">
                            <div>
                              <h6 className="mb-1 fw-bold text-muted">
                                <i className="fa fa-user text-secondary" />{" "}
                                {item.PersonName}
                              </h6>
                              <p className="mb-0 small text-muted">
                                <i class="fa fa-cog me-1"></i>{" "}
                                {item.ServiceName}
                              </p>
                              <p className="mb-1 small text-muted">
                                <i className="fa fa-building-o me-1 text-dark" />{" "}
                                {item.CompanyName}
                              </p>
                              <p className="mb-0 small text-muted">
                                <i className="fa fa-phone me-1 text-danger" />{" "}
                                {item.EmailId}
                              </p>
                              <p className="mb-0 small text-muted">
                                <i className="fa fa-envelope-o me-1 text-primary" />
                                {item.MobileNo}
                              </p>
                              <p className="mb-0 small text-muted fw-bold">
                                <i className="fa fa-circle text-muted " />{" "}
                                &nbsp;{item.Type}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="col-md-3 col-sm-4">
                        {item.isAddDD ? (
                          <div
                            className="card border-0 rounded-3 shadow-sm"
                            style={{ borderLeft: "5px solid #198754" }}
                          >
                            <div className="card-body p-2 d-flex align-items-start">
                              <div>
                                <h6 className="mb-1 fw-bold text-success">
                                  <i className="fa fa-user text-success" />{" "}
                                  {item.PersonName}
                                </h6>
                                <p className="mb-0 small text-muted">
                                  <i class="fa fa-cog me-1 text-dark"></i>{" "}
                                  {item.ServiceName}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-building-o me-1 text-dark" />{" "}
                                  {item.CompanyName}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-envelope-o me-1 text-primary" />
                                  {item.EmailId}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-phone me-1 text-success" />{" "}
                                  {item.MobileNo}
                                </p>
                                <p className="mb-0 small text-success fw-bold">
                                  <i className="fa fa-circle text-success" />
                                  &nbsp;{item.Type}
                                </p>
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() => this.openModal(i)}
                                >
                                  <span className="badge bg-primary text-white fw-normal">
                                    Update DD Details
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            className={`shadow-sm ${iaMandatory ? "blink-border" : ""
                              }`}
                            style={{
                              backgroundColor: "white",
                              border: iaMandatory ? "2px solid red" : "none", // fallback for non-animated
                            }}
                          >
                            <div className="card-body p-2 d-flex align-items-start">
                              <div>
                                <h6 className="mb-1 fw-bold text-warning">
                                  <i className="fa fa-user text-warning" />{" "}
                                  {item.PersonName}
                                </h6>
                                <p className="mb-0 small text-muted">
                                  <i class="fa fa-cog me-1 text-dark"></i>{" "}
                                  {item.ServiceName}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-building-o me-1 text-dark" />{" "}
                                  {item.CompanyName}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-envelope-o me-1 text-primary" />{" "}
                                  {item.EmailId}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-phone me-1 text-warning" />{" "}
                                  {item.MobileNo}
                                </p>
                                <p className="mb-0 small text-warning fw-bold">
                                  <i className="fa fa-circle text-warning" />{" "}
                                  {item.Type}
                                </p>
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() => this.openModal(i)}
                                >
                                  <span className="badge bg-warning text-white fw-normal">
                                    Add DD Details
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  )}
                </div>
              ) : <></>}
            </div>
            <div className="row">
              <div className="col-md-4">
                <label className="col-form-label">
                  ITME Staff Name<span className="text-red">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={ITMEStaffName}
                  disabled={IsNDCIssued}
                  onChange={(e) =>
                    this.setState({
                      ITMEStaffName: e.target.value.replace(/[^a-zA-Z ]/g, ""),
                      ITMEStaffNameErr: "",
                    })
                  }
                />
                {
                  <span className="text-danger text-start text-left d-block mt-1">
                    {ITMEStaffNameErr}
                  </span>
                }
              </div>
              <div className="col-md-4">
                <label className="col-form-label">
                  Issued Date<span className="text-red">*</span>
                </label>
                <DatePicker
                  selected={IssuedDate ? moment(IssuedDate).toDate() : null}
                  disabled={IsNDCIssued}
                  minDate={new Date()}
                  minTime={new Date()}
                  maxTime={new Date().setHours(23, 59, 59, 999)}
                  onChange={(e) =>
                    this.setState({ IssuedDate: e, IssuedDateErr: "" })
                  }
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={1} // choose time in 15-min steps
                  dateFormat="dd-MM-yyyy HH:mm"
                  placeholderText="Select date and time"
                  className="form-control"
                />
                {
                  <span className="text-danger text-start text-left d-block mt-1">
                    {IssuedDateErr}
                  </span>
                }
              </div>
            </div>
            <div className="row">
              <div className="col-md-8">
                <label className="col-form-label">Remark</label>
                <textarea
                  type="text"
                  className="form-control"
                  rows={4}
                  value={Remark}
                  maxLength={1000}
                  onChange={(e) => this.setState({ Remark: e.target.value })}
                />
              </div>
            </div>

            <div className="mb-5 text-end p-0 py-2 mt-3">
              <button
                className="btn btn-aqua mx-2"
                onClick={() => this.onSubmit(true)}
              >
                {" "}
                {IsNDCIssued ? "Update" : "Marked NDC Issued"}
              </button>
              {IsNDCIssued && (
                <>
                  <button
                    className="btn btn btn-aqua"
                    onClick={() => this.sendNoDues()}
                  >
                    Send NoDues
                  </button>
                  <button
                    className="btn btn btn-aqua mx-2"
                    onClick={() => this.viewNoDues()}
                  >
                    Print
                  </button>
                </>
              )}
              <button
                className="btn btn-gray "
                onClick={() => this.handleCancel()}
              >
                Back
              </button>
            </div>
          </div>
          <Footer />
        </div>

        <Modal
          isOpen={isOpen}
          onRequestClose={() => this.setState({ isOpen: false })}
        >
          {/* <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Additional Furniture</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div>
                            </div>

                        </div>
                    </div> */}

          {/* <div className="modal-dialog modal-xl modal-dialog-centered" style={{ marginLeft: '325px', marginTop: '60px' }}> */}

          <div className="modal-dialog modal-almost-fullscreen">
            <div className="modal-content">
              <div className="modal-header rounded-top-4 p-2">
                <h6 className="modal-title"> Add DD Details</h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => this.handleModalCancel()}
                />
              </div>
              {/* Body */}
              <div className="modal-body">
                {vendorList.length > 0 ? (
                  vendorList.map((data, parentIndex) => (
                    <>
                      {vendorIndex == parentIndex && (
                        <div>
                          {data.ExhStallPossessionVendorDDdetailsID &&
                            <div className="dd-checkbox" style={{ zIndex: 99999999 }}>
                              <label className="mt-1" style={{ cursor: 'pointer' }}
                              >
                                <input
                                  type="checkbox"
                                  checked={data.IsDDSubmitted}
                                  onClick={(e) =>
                                    this.handleInput(
                                      e,
                                      "checkbox",
                                      "IsDDSubmitted",
                                      parentIndex,
                                      null,
                                      data.ExhStallPossessionVendorDDdetailsID
                                    )
                                  }
                                />
                                Tag DD Received
                              </label>
                            </div>
                          }
                          <div className="row g-3 mb-3">
                            <div className="col-md-3 mt-0">
                              <label className="form-label">
                                DD Number<span className="text-red">*</span>
                              </label>
                              <input
                                type="text"
                                maxLength={100}
                                value={data.DD_Number}
                                className="form-control"
                                onChange={(e) =>
                                  this.handleInput(
                                    e,
                                    "varchar",
                                    "DD_Number",
                                    parentIndex
                                  )
                                }
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {data.DD_NumberErr}
                                </span>
                              }
                            </div>
                            <div className="col-md-3 mt-0">
                              <label className="form-label">
                                DD Date<span className="text-red">*</span>
                              </label>
                              <DatePicker
                                style={{ zIndex: "99999" }}
                                selected={
                                  data.DD_Date ? new Date(data.DD_Date) : null
                                }
                                dateFormat={"dd/MM/yyyy"}
                                className="form-control"
                                onChange={(e) =>
                                  this.handleInput(
                                    e,
                                    "date",
                                    "DD_Date",
                                    parentIndex
                                  )
                                }
                                peekNextMonth
                                // minDate={fromDate}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText="To Date"
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {data.DD_DateErr}
                                </span>
                              }
                            </div>
                            <div className="col-md-3 mt-0">
                              <label className="form-label">
                                DD Amount<span className="text-red">*</span>
                              </label>
                              <input
                                type="text"
                                value={data.DD_Amount}
                                maxLength={100}
                                className="form-control"
                                onChange={(e) =>
                                  this.handleInput(
                                    e,
                                    "int",
                                    "DD_Amount",
                                    parentIndex
                                  )
                                }
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {data.DD_AmountErr}
                                </span>
                              }
                            </div>
                            <div className="col-md-3 mt-0">
                              <label className="form-label">
                                Bank Name<span className="text-red">*</span>
                              </label>
                              <input
                                type="text"
                                value={data.DD_BankName}
                                maxLength={200}
                                className="form-control"
                                onChange={(e) =>
                                  this.handleInput(
                                    e,
                                    "varchar",
                                    "DD_BankName",
                                    parentIndex
                                  )
                                }
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {data.DD_BankNameErr}
                                </span>
                              }
                            </div>
                            <div class="card shadow-none border-0 mt-1 mb-0 col-md-6">
                              <div class="text-dark py-2 fw-bold text-muted text-left">
                                DD Image{" "}
                              </div>
                              <div class="card-body border rounded p-2">
                                <div class="row g-2 align-items-center">
                                  <div class="col-md-12">
                                    <label class=" mb-1">
                                      Capture / Upload Photo
                                    </label>
                                    {data.DDFileName != null &&
                                      data.DDFilePath != null ? (
                                      <>
                                        {data.DDFileName != null &&
                                          data.DDFileType != null ? (
                                          <div
                                            className="d-flex"
                                            style={{ justifyContent: "left" }}
                                          >
                                            <div className="chooseStallFile m-0" style={{ width: '60%' }}>
                                              <p
                                                className="overflow-membership m-0 text-left"
                                                onClick={() =>
                                                  this.handleViewFile(
                                                    data.DDFilePath
                                                  )
                                                }
                                                style={{ cursor: "pointer" }}
                                              >
                                                {data.DDFileName}
                                              </p>
                                              <span
                                                className="membership_file_cross text-danger"
                                                onClick={() =>
                                                  this.handleRemoveFile2(
                                                    parentIndex
                                                  )
                                                }
                                              >
                                                X
                                              </span>
                                            </div>
                                          </div>
                                        ) : (
                                          <div
                                            className="d-flex"
                                            style={{ justifyContent: "left" }}
                                          >
                                            <div className="chooseStallFile m-0" style={{ width: '60%' }}>
                                              <a
                                                className="overflow-membership m-0 text-left"
                                                target="_blank"
                                                href={
                                                  BASE_URL.split("/api")[0] +
                                                  data.DDFilePath
                                                }
                                                style={{ cursor: "pointer" }}
                                              >
                                                {data.DDFileName}
                                              </a>
                                              <span
                                                className="membership_file_cross text-danger"
                                                onClick={() =>
                                                  this.handleRemoveFile2(
                                                    parentIndex
                                                  )
                                                }
                                              >
                                                X
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      <div class="d-block d-md-flex align-items-md-center">
                                        <button
                                          class="btn btn-aqua mb-2 mb-md-0"
                                          onClick={() =>
                                            this.handleOpenModal2(parentIndex)
                                          }
                                        >
                                          <i class="bi bi-camera"></i> Open Camera
                                        </button>
                                        <span class="mx-2 text-muted">or</span>
                                        <span></span>
                                        <input
                                          type="file"
                                          class="form-control w-auto"
                                          id="inputGroupFile"
                                          onChange={(e) =>
                                            this.handleInput(
                                              e,
                                              "file",
                                              "DDDocument",
                                              parentIndex
                                            )
                                          }
                                          accept={".jpg,.jpeg,.png"}
                                        />
                                        &nbsp;<br />
                                        <span
                                          className="text-aqua"
                                          style={{
                                            fontSize: "12px",
                                            textAlign: "center",
                                            display: "block",
                                          }}
                                        >
                                          Max 5MB | Jpeg, Jpg, Png only
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {data.DDFileNameErr}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="mt-3">
                            {/* DD Submitted By */}
                            <div class="card shadow-none border rounded-3 p-0"><div class="card-header  text-dark py-2 bg-card-header">
                              DD Submitted By
                            </div>
                              <div
                                className="card-body p-0"
                                id="submittedSection"
                              >
                                <div className="rounded p-2 mb-0">
                                  <div className="row g-2">
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Company Name
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        value={data.DD_SubmitCompanyName}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_SubmitCompanyName",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_SubmitCompanyNameErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Person Name
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        value={data.DD_SubmitPersonName}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_SubmitPersonName",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_SubmitPersonNameErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Email<span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="email"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        value={data.DD_SubmitEmailId}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_SubmitEmailId",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_SubmitEmailIdErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Mobile No
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={10}
                                        value={data.DD_SubmitMobileNo}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "int",
                                            "DD_SubmitMobileNo",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_SubmitMobileNoErr}
                                        </span>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* DD Returned By */}
                            <div class="card shadow-none border rounded-3 p-0">
                              <div class="card-header  text-dark py-2 bg-card-header">
                                DD Return To
                              </div>
                              <div
                                className="card-body p-0"
                                id="submittedSection"
                              >
                                <div className="rounded p-2 mb-0">
                                  <div className="row g-2">

                                    <div className="">
                                      <label className="d-flex align-items-center">
                                        <input
                                          type="checkbox"
                                          value={`SameAsAbove_${parentIndex}`}
                                          checked={data.SameAsAbove}
                                          onChange={(e) =>
                                            this.handleInput(
                                              e,
                                              "checkbox",
                                              "SameAsAbove",
                                              parentIndex
                                            )
                                          }
                                          className="mr-2 m-1 me-2"
                                        />
                                        Same as above
                                      </label>
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Company Name
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        disabled={data.SameAsAbove}
                                        value={data.DD_ReturnCompanyName}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_ReturnCompanyName",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_ReturnCompanyNameErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Person Name
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        disabled={data.SameAsAbove}
                                        value={data.DD_ReturnPersonName}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_ReturnPersonName",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_ReturnPersonNameErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Email<span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="email"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        disabled={data.SameAsAbove}
                                        value={data.DD_ReturnEmailId}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_ReturnEmailId",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_ReturnEmailIdErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Mobile No
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={10}
                                        disabled={data.SameAsAbove}
                                        value={data.DD_ReturnMobileNo}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "int",
                                            "DD_ReturnMobileNo",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_ReturnMobileNoErr}
                                        </span>
                                      }
                                    </div>

                                    <div class="card shadow-none border-0 mt-1 mb-0  mb-0 col-md-6">
                                      <div class="text-dark py-2 fw-bold text-muted text-left">
                                        Photo ID{" "}
                                        <small>(Government Approved Document)</small>
                                      </div>
                                      <div class="card-body border rounded p-2">
                                        <div class="row g-2 align-items-center">
                                          <div class="col-md-12">
                                            <label class=" mb-1">
                                              Capture / Upload Photo
                                            </label>
                                            {data.FileName != null &&
                                              data.FilePath != null ? (
                                              <>
                                                {data.FileName != null &&
                                                  data.FileType != null ? (
                                                  <div
                                                    className="d-flex"
                                                    style={{ justifyContent: "left" }}
                                                  >
                                                    <div className="chooseStallFile m-0" style={{ width: '60%' }}>
                                                      <p
                                                        className="overflow-membership m-0 text-left"
                                                        onClick={() =>
                                                          this.handleViewFile(
                                                            data.FilePath
                                                          )
                                                        }
                                                        style={{ cursor: "pointer" }}
                                                      >
                                                        {data.FileName}
                                                      </p>
                                                      <span
                                                        className="membership_file_cross text-danger"
                                                        onClick={() =>
                                                          this.handleRemoveFile(
                                                            parentIndex
                                                          )
                                                        }
                                                      >
                                                        X
                                                      </span>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div
                                                    className="d-flex"
                                                    style={{ justifyContent: "left" }}
                                                  >
                                                    <div className="chooseStallFile m-0" style={{ width: '60%' }}>
                                                      <a
                                                        className="overflow-membership m-0 text-left"
                                                        target="_blank"
                                                        href={
                                                          BASE_URL.split("/api")[0] +
                                                          data.FilePath
                                                        }
                                                        style={{ cursor: "pointer" }}
                                                      >
                                                        {data.FileName}
                                                      </a>
                                                      <span
                                                        className="membership_file_cross text-danger"
                                                        onClick={() =>
                                                          this.handleRemoveFile(
                                                            parentIndex
                                                          )
                                                        }
                                                      >
                                                        X
                                                      </span>
                                                    </div>
                                                  </div>
                                                )}
                                              </>
                                            ) : (
                                              <div class="d-block d-md-flex align-items-md-center">
                                                <button
                                                  class="btn btn-aqua mb-2 mb-md-0"
                                                  onClick={() =>
                                                    this.handleOpenModal(parentIndex)
                                                  }
                                                >
                                                  <i class="bi bi-camera"></i> Open Camera
                                                </button>
                                                <span class="mx-2 text-muted">or</span>
                                                <span></span>
                                                <input
                                                  type="file"
                                                  class="form-control w-auto"
                                                  id="inputGroupFile"
                                                  onChange={(e) =>
                                                    this.handleInput(
                                                      e,
                                                      "file",
                                                      "Document",
                                                      parentIndex
                                                    )
                                                  }
                                                  accept={".jpg,.jpeg,.png"}
                                                />
                                                &nbsp; <br />
                                                <span
                                                  className="text-aqua"
                                                  style={{
                                                    fontSize: "12px",
                                                    textAlign: "center",
                                                    display: "block",
                                                  }}
                                                >
                                                  Max 5MB | Jpeg, Jpg, Png only
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                          {
                                            <span className="text-danger text-start text-left d-block mt-1">
                                              {data.FileNameErr}
                                            </span>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Add Subcontractor Button */}
                          <div className="mb-2 mt-3">
                            <button
                              type="button"
                              className="btn btn-aqua p-1"
                              onClick={() => {
                                const updatedList = [...this.state.vendorList];
                                updatedList[parentIndex].subContractorList.push(
                                  {
                                    CompanyName: "",
                                    PersonName: "",
                                    EmailId: "",
                                    MobileNo: "",
                                  }
                                );
                                this.setState({ vendorList: updatedList });
                              }}
                            >
                              <i className="ri-add-line me-1" /> Add
                              Subcontractor
                            </button>
                          </div>

                          {/* Subcontractor Table */}
                          <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                              <thead className="table-light">
                                <tr>
                                  <th>Company Name</th>
                                  <th>Person Name</th>
                                  <th>Email</th>
                                  <th>Mobile No</th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.subContractorList.length > 0 ? (
                                  data.subContractorList.map(
                                    (item, childIndex) => (
                                      <tr key={childIndex}>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.CompanyName}
                                            maxLength={100}
                                            className="form-control"
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "varchar",
                                                "CompanyName",
                                                parentIndex,
                                                childIndex
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.PersonName}
                                            maxLength={100}
                                            className="form-control"
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "varchar",
                                                "PersonName",
                                                parentIndex,
                                                childIndex
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.EmailId}
                                            maxLength={100}
                                            className="form-control"
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "varchar",
                                                "EmailId",
                                                parentIndex,
                                                childIndex
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.MobileNo}
                                            maxLength={10}
                                            className="form-control"
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "int",
                                                "MobileNo",
                                                parentIndex,
                                                childIndex
                                              )
                                            }
                                          />
                                        </td>
                                        <td className="text-center">
                                          <i
                                            className="fa fa-trash text-danger"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.handleDelete(
                                                parentIndex,
                                                childIndex
                                              )
                                            }
                                          />
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      Record not found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </>
                  ))
                ) : (
                  <div className="text-center">Record not found</div>
                )}
              </div>
              <div className="modal-footer py-1">
                <button
                  type="button"
                  className="btn btn-aqua"
                  onClick={() => this.onSaveModal()}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-gray"
                  onClick={() => this.handleModalCancel()}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </Modal>
        <ImageCapture
          isOpen={isImageModal}
          onClose={this.handleCloseModal}
          onCapture={this.handleCapture}
        />
        <ImageCapture
          isOpen={isImageModal2}
          onClose={this.handleCloseModal2}
          onCapture={this.handleCapture2}
        />

        <Modal
          isOpen={isConfirm}
          onRequestClose={() => this.setState({ isConfirm: false })}
        >
          <div class="modal-dialog modal-s modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-4">
              {/* Header */}
              <div className="modal-header rounded-top-4 p-2">
                <h6 className="modal-title"> Confirm!</h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => this.setState({ isConfirm: false })}
                />
              </div>
              {/* Body */}
              <div className="modal-body">
                <h6>Do you want to mark this DD as received and acknowledge it to the contractor?</h6>
              </div>
              <div className="modal-footer py-1">
                <button
                  type="button"
                  className="btn btn-aqua"
                  onClick={() => this.tagDDSubmit(this.state.ExhStallPossessionVendorDDdetailsID, true, true)}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-gray"
                  onClick={() => this.setState({ isConfirm: false })}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.isExhibitPop}
          onRequestClose={() => this.setState({ isExhibitPop: false })}
        >
          <div class="modal-dialog modal-almost-fullscreen">
            <div className="modal-content shadow-lg border-0 rounded-4">

              {/* Header */}
              <div className="modal-header rounded-top-4 p-2">
                <h6 className="modal-title">Exhibit Details</h6>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => this.setState({ isExhibitPop: false })}
                />
              </div>

              {/* Body */}
              <div className="modal-body">

                <div
                  class="container-fluid"
                  ref={this.targetRef}
                >

                  <div
                    class="accordion"
                    id="exhibitAccordion"
                  >

                    {subChapters.length > 0 ? (

                      subChapters.map((data, index) => (

                        <div
                          class="accordion-item-exhdetail"
                          key={index}
                        >

                          {/* ================= HEADER ================= */}
                          <h2
                            class="accordion-header-exhdetail"
                            id={`heading${index}`}
                          >

                            <button
                              class="accordion-button"
                              type="button"
                              style={{
                                border: 'none',
                                backgroundColor: 'transparent !important',
                                fontWeight: 'normal',
                                boxShadow: 'none !important'
                              }}
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapseOne_${index}`}
                              aria-expanded={data.accordion}
                              aria-controls={`collapseOne_${index}`}
                            >

                              {data.ChapterID != 0 ? (

                                <p
                                  style={{
                                    marginBottom: '2px',
                                    marginTop: '0.1rem',
                                    color: '#000',
                                    fontSize: '1.05rem',
                                    padding: '5px 20px'
                                  }}
                                >
                                  {data.ChapterName}
                                </p>

                              ) : (

                                <input
                                  style={{ width: '90%' }}
                                  type="text"
                                  className="form-control"
                                  value={data.ChapterName}
                                  disabled={true}
                                />

                              )}

                              {/* DELETE ICON REMOVED */}

                            </button>

                          </h2>


                          {/* ================= BODY ================= */}
                          <div
                            id={`collapseOne_${index}`}
                            class="accordion-collapse collapse show"
                            aria-labelledby={`heading${index}`}
                            data-bs-parent="#exhibitAccordion"
                          >

                            {/* 
                      FIELDSET DISABLED
                      ----------------
                      Everything inside this fieldset is read-only.
                      This includes:
                      - input
                      - checkbox
                      - select
                      - file input
                      - buttons inside the form
                    */}
                            <fieldset disabled>

                              <div class="accordion-body-exhdetail">


                                {/* ================= ROW 1 ================= */}
                                <div class="row mb-3 gx-3">

                                  {/* Company */}
                                  <div class="col-md-3">

                                    <div class="mb-3">

                                      <label class="form-label-exhdetail border-0">
                                        Manufacturing/Exhibiting Company Name
                                        <span className="text-red">*</span>
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        maxLength={'200'}
                                        value={data.ManufacturerName}
                                        style={{
                                          border:
                                            data.errArr.includes('ManufacturerName') &&
                                            '2px solid red'
                                        }}
                                      />

                                    </div>


                                    {/* Manufacturing Country */}
                                    <div class="mb-3">

                                      <label class="form-label-exhdetail border-0">
                                        Manufacturing Country/Country of Origin
                                        <span className="text-red">*</span>
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        required=""
                                        value={data.ManufacturingCountry}
                                        style={{
                                          border:
                                            data.errArr.includes('ManufacturingCountry') &&
                                            '2px solid red'
                                        }}
                                      />

                                    </div>

                                  </div>


                                  {/* Email + HQ */}
                                  <div class="col-md-6 mb-2">

                                    <div class="mb-3">

                                      <label class="form-label-exhdetail border-0">
                                        Company/Official Email
                                        <span className="text-red">*</span>
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        required=""
                                        style={{
                                          border:
                                            data.errArr.includes('CompanyEmail') &&
                                            '2px solid red'
                                        }}
                                        value={data.CompanyEmail}
                                      />

                                    </div>


                                    <div class="mb-3">

                                      <label class="form-label-exhdetail border-0">
                                        Registered Headquarters Address
                                        <span className="text-red">*</span>
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        required=""
                                        value={data.registrationHQaddress}
                                        style={{
                                          border:
                                            data.errArr.includes('registrationHQaddress') &&
                                            '2px solid red'
                                        }}
                                      />

                                    </div>

                                  </div>


                                  {/* Machine / Product / Brochure */}
                                  <div
                                    class="col-md-3 mb-2"
                                    style={{
                                      minWidth: '11rem',
                                      background:
                                        data.errArr.includes('isAllMB') &&
                                        '#ff00002b'
                                    }}
                                  >

                                    <div className='border p-0 rounded-2 mt-2'>

                                      <label class="form-label-exhdetail border-0 d-block border-bottom p-2">
                                        Machine/Products/Only Brochure
                                        <span className="text-red">*</span>
                                      </label>

                                      <div class="align-items-center flex-wrap p-2 pt-0">

                                        {/* Machine */}
                                        <div class="mb-1 m-0">

                                          <input
                                            className="toggle-box mt-1"
                                            id={`machine-${index}`}
                                            type="checkbox"
                                            style={{ float: "left" }}
                                            checked={data.isMachine}
                                            readOnly
                                          />

                                          <label
                                            class="form-check-label checkbox-label border-0"
                                            htmlFor={`machine-${index}`}
                                          >
                                            Machine
                                          </label>

                                        </div>


                                        {/* Product */}
                                        <div class="mb-1">

                                          <input
                                            className="toggle-box mt-1"
                                            id={`product-${index}`}
                                            type="checkbox"
                                            style={{ float: "left" }}
                                            checked={data.IsAccessory}
                                            readOnly
                                          />

                                          <label
                                            class="form-check-label checkbox-label border-0"
                                            htmlFor={`product-${index}`}
                                          >
                                            Product
                                          </label>

                                        </div>


                                        {/* Brochure */}
                                        <div class="mb-1">

                                          <input
                                            className="toggle-box mt-1"
                                            id={`brochure-${index}`}
                                            type="checkbox"
                                            style={{ float: "left" }}
                                            checked={data.isBrochure}
                                            readOnly
                                          />

                                          <label
                                            class="form-check-label checkbox-label border-0"
                                            htmlFor={`brochure-${index}`}
                                          >
                                            Only Brochure
                                          </label>

                                        </div>

                                      </div>

                                    </div>

                                  </div>

                                </div>


                                {/* ================= ROW 2 ================= */}
                                <div class="row mb-3 gx-3">

                                  {/* Machine Details + HSN */}
                                  <div class="col-md-3">

                                    <div class="mb-3">

                                      <label class="form-label-exhdetail border-0">
                                        Machine Details
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        maxLength={'200'}
                                        value={data.MachineDetails}
                                      />

                                    </div>


                                    <div class="mb-3">

                                      <label class="form-label-exhdetail border-0">
                                        HSN Code
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        maxLength={'200'}
                                        value={data.HSNCode}
                                      />

                                    </div>

                                  </div>


                                  {/* Machine Dimension */}
                                  <div class="col-md-3 mb-3">

                                    <div class="nested-card h-100">

                                      <div class="nested-card-title">
                                        Machine Dimension (mtr)

                                        {data.isMachine && (
                                          <span className="text-red">*</span>
                                        )}

                                      </div>


                                      <div class="table-like">

                                        {/* Length */}
                                        <div class="table-col">

                                          <div class="table-label">
                                            Length
                                            {data.isMachine && (
                                              <span className="text-red">*</span>
                                            )}
                                          </div>

                                          <input
                                            type="text"
                                            className="form-control"
                                            maxLength={'9'}
                                            value={
                                              (data.isBrochure ||
                                                data.IsAccessory) &&
                                                !data.isMachine
                                                ? 0
                                                : data.Length
                                            }
                                            disabled={true}
                                          />

                                        </div>


                                        {/* Breadth */}
                                        <div class="table-col">

                                          <div class="table-label">
                                            Breadth
                                            {data.isMachine && (
                                              <span className="text-red">*</span>
                                            )}
                                          </div>

                                          <input
                                            type="text"
                                            className="form-control"
                                            maxLength={'9'}
                                            value={
                                              (data.isBrochure ||
                                                data.IsAccessory) &&
                                                !data.isMachine
                                                ? 0
                                                : data.Breadth
                                            }
                                            disabled={true}
                                          />

                                        </div>


                                        {/* Area */}
                                        <div class="table-col">

                                          <div class="table-label">
                                            Area
                                            {data.isMachine && (
                                              <span className="text-red">*</span>
                                            )}
                                          </div>

                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              (data.isBrochure ||
                                                data.IsAccessory) &&
                                                !data.isMachine
                                                ? 0
                                                : data.Area
                                            }
                                            disabled={true}
                                          />

                                        </div>


                                        {/* Height */}
                                        <div class="table-col">

                                          <div class="table-label">
                                            Height
                                            {data.isMachine && (
                                              <span className="text-red">*</span>
                                            )}
                                          </div>

                                          <input
                                            type="text"
                                            className="form-control"
                                            maxLength={'9'}
                                            value={
                                              (data.isBrochure ||
                                                data.IsAccessory) &&
                                                !data.isMachine
                                                ? 0
                                                : data.Height
                                            }
                                            disabled={true}
                                          />

                                        </div>

                                      </div>

                                    </div>

                                  </div>


                                  {/* Calculated Area + Scheme */}
                                  <div class="col-md-3">

                                    <div class="mb-3">

                                      <label class="form-label-exhdetail border-0">
                                        Calculated Area
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        maxLength={'10'}
                                        value={
                                          data.CalculatedArea != 0 &&
                                            data.CalculatedArea != null
                                            ? data.CalculatedArea
                                            : ''
                                        }
                                        disabled
                                      />

                                    </div>


                                    <div class="mb-3">

                                      <label class="form-label-exhdetail border-0">
                                        Scheme Type
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        maxLength={'10'}
                                        value={
                                          data.ShellScheme == 2
                                            ? 'Shell'
                                            : data.ShellScheme == 1
                                              ? 'Bare'
                                              : ''
                                        }
                                        disabled
                                      />

                                    </div>

                                  </div>


                                  {/* Floor Loading + Weight */}
                                  <div class="col-md-3">

                                    <div class="mb-3">

                                      <label class="form-label-exhdetail border-0">
                                        Floor Loading Requirements (Kgs per sq mtr)
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control"
                                        maxLength={'9'}
                                        value={
                                          (data.isBrochure ||
                                            data.IsAccessory) &&
                                            !data.isMachine
                                            ? 0
                                            : data.FloorCapacity
                                        }
                                      />

                                    </div>


                                    <div class="mb-3">

                                      <label class="form-label-exhdetail border-0">
                                        Machine Weight (Kg)
                                      </label>

                                      <input
                                        type="number"
                                        className="form-control"
                                        maxLength={'9'}
                                        value={
                                          (data.isBrochure ||
                                            data.IsAccessory) &&
                                            !data.isMachine
                                            ? 0
                                            : data.MachineWeight
                                        }
                                      />

                                    </div>

                                  </div>

                                </div>


                                {/* ================= ROW 3 ================= */}
                                <div class="row gx-3">

                                  {/* POWER */}
                                  <div class="col-md-3 mb-3">

                                    <div class="nested-card h-100">

                                      <div class="nested-card-title no-border">

                                        Power Requirement
                                        <span class="text-danger">*</span>

                                        &nbsp;&nbsp;

                                        <i
                                          title="View Power Requirement Rates"
                                          class="bi bi-info-circle"
                                          onClick={() =>
                                            this.setState({
                                              isOpenUtility: true,
                                              UtilityName: 'Power'
                                            })
                                          }
                                        ></i>

                                        <br />

                                      </div>

                                      <span class="text-danger-small">
                                        (Please review the utility rates in the manual
                                        form)
                                      </span>


                                      <div class="table-like border-top">

                                        {/* Single Phase */}
                                        <div class="table-col">

                                          <div class="table-label">
                                            Single Phase (K.W.)
                                          </div>

                                          <input
                                            type="number"
                                            className="form-control"
                                            maxLength={'10'}
                                            value={data.SinglePhasePower}
                                            disabled={true}
                                          />

                                        </div>


                                        {/* Three Phase */}
                                        <div class="table-col">

                                          <div class="table-label">
                                            Three Phase (K.W.)
                                          </div>

                                          <input
                                            type="number"
                                            className="form-control"
                                            maxLength={'10'}
                                            value={data.ThreePhasePower}
                                            disabled={true}
                                          />

                                        </div>

                                      </div>

                                    </div>

                                  </div>


                                  {/* WATER */}
                                  <div class="col-md-3 mb-3">

                                    <div class="nested-card h-100">

                                      <div class="nested-card-title no-border">

                                        Water Requirement
                                        <span class="text-danger">*</span>

                                        &nbsp;&nbsp;

                                        <i
                                          title="View Water Requirement Rates"
                                          class="bi bi-info-circle"
                                          onClick={() =>
                                            this.setState({
                                              isOpenUtility: true,
                                              UtilityName: 'Water'
                                            })
                                          }
                                        ></i>

                                        <br />

                                      </div>

                                      <span class="text-danger-small">
                                        (Please review the utility rates in the manual
                                        form)
                                      </span>


                                      <div class="table-like border-top">

                                        {/* Water Consumption */}
                                        <div class="table-col">

                                          <div class="table-label">
                                            Consumption Of Water(Ltr/hr)
                                            <span class="text-danger">*</span>
                                          </div>

                                          <input
                                            type="number"
                                            className="form-control"
                                            maxLength={'10'}
                                            value={data.WaterConsumption}
                                            disabled={true}
                                          />

                                        </div>


                                        {/* Inlet */}
                                        <div class="table-col">

                                          <div class="table-label">
                                            Inlet Connection
                                            <span class="text-danger">*</span>
                                          </div>

                                          <input
                                            type="number"
                                            className="form-control"
                                            maxLength={'10'}
                                            value={data.InletQuantity}
                                            disabled={true}
                                          />

                                        </div>


                                        {/* Outlet */}
                                        <div class="table-col">

                                          <div class="table-label">
                                            Outlet Connection
                                            <span class="text-danger">*</span>
                                          </div>

                                          <input
                                            type="number"
                                            className="form-control"
                                            maxLength={'10'}
                                            value={data.OutletQuantity}
                                            disabled={true}
                                          />

                                        </div>

                                      </div>

                                    </div>

                                  </div>


                                  {/* AIR */}
                                  <div class="col-md-4 mb-3">

                                    <div class="nested-card h-100">

                                      <div class="nested-card-title no-border">

                                        Air Requirement
                                        <span class="text-danger">*</span>

                                        &nbsp;&nbsp;

                                        <i
                                          title="View Air Requirement Rates"
                                          class="bi bi-info-circle"
                                          onClick={() =>
                                            this.setState({
                                              isOpenUtility: true,
                                              UtilityName: 'Air'
                                            })
                                          }
                                        ></i>

                                        <br />

                                      </div>

                                      <span class="text-danger-small">
                                        (Please review the utility rates in the manual
                                        form)
                                      </span>


                                      <div class="table-like border-top">

                                        {/* Bar Quantity */}
                                        <div class="table-col">

                                          <div class="table-label">
                                            Bar Quantity
                                            <span class="text-danger">*</span>
                                          </div>

                                          <select
                                            className="form-control select2 select-hidden-accessible pl-0"
                                            value={data.BarQuantity}
                                            disabled={true}
                                          >

                                            <option value="0">
                                              NA
                                            </option>

                                            {
                                              this.state.barQuantityList.length > 0 &&
                                              this.state.barQuantityList.map(item => (

                                                <option
                                                  value={item.BarQuantity}
                                                  key={item.BarQuantity}
                                                >
                                                  {item.BarQuantity}
                                                </option>

                                              ))
                                            }

                                          </select>

                                        </div>


                                        {/* CFM Quantity */}
                                        <div class="table-col">

                                          <div class="table-label">
                                            CFM Quantity
                                            <span class="text-danger">*</span>
                                          </div>

                                          <select
                                            className="form-control select2 select-hidden-accessible pl-0"
                                            value={data.CFMQuantity}
                                            disabled={true}
                                          >

                                            <option value="0">
                                              NA
                                            </option>

                                            {
                                              this.state.CFMQuantityList.length > 0 &&
                                              this.state.CFMQuantityList.map(item => (

                                                <option
                                                  value={item.CFMID}
                                                  key={item.CFMID}
                                                >
                                                  {item.CFM}
                                                </option>

                                              ))
                                            }

                                          </select>

                                        </div>


                                        {/* Max Compressed Air */}
                                        <div class="table-col">

                                          <div class="table-label">

                                            Max Compressed Air Connection
                                            <span class="text-danger">*</span>

                                          </div>

                                          <input
                                            type="number"
                                            className="form-control"
                                            maxLength={'10'}
                                            value={data.MaxCompressedAir}
                                            disabled={true}
                                          />

                                        </div>

                                      </div>

                                    </div>

                                  </div>


                                  {/* ================= DOCUMENT ================= */}
                                  <div class="col-md-2 mb-3">

                                    <div class="nested-card h-100">

                                      <div
                                        class="nested-card-title text-white"
                                        style={{
                                          background: '#3dbca7'
                                        }}
                                      >

                                        Upload Certificate of Origin /
                                        Manufacturing license

                                        {(data.isMachine ||
                                          data.IsAccessory) && (
                                            <span className="text-red">
                                              *
                                            </span>
                                          )}

                                      </div>


                                      {(data.isMachine ||
                                        data.IsAccessory) ? (

                                        data.DocDeleted == false ||
                                          data.DocumentName != '' ? (

                                          <div
                                            style={{
                                              margin: '2rem 1rem',
                                              border: '1px solid #ccc',
                                              padding: '10px',
                                              display: 'inline-flex',
                                              alignItems: 'center',
                                              background:
                                                data.errArr.includes('Origin') &&
                                                '#ff00002b'
                                            }}
                                          >

                                            {/* DOCUMENT */}
                                            {data.DocDeleted == false ? (

                                              <a
                                                href={data.DocumentPath}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >

                                                <span
                                                  style={{
                                                    marginRight: '10px'
                                                  }}
                                                >
                                                  {data.DocumentName}
                                                </span>

                                              </a>

                                            ) : (

                                              <span
                                                onClick={() =>
                                                  this.renderNewImage(
                                                    data.DocumentFile,
                                                    data.DocumentType
                                                  )
                                                }
                                                style={{
                                                  marginRight: '10px',
                                                  cursor: 'pointer'
                                                }}
                                              >
                                                {data.DocumentName}
                                              </span>

                                            )}

                                            {/* DOCUMENT DELETE ICON REMOVED */}

                                          </div>

                                        ) : (

                                          <div
                                            className="upload-container mt-1"
                                            style={{
                                              background:
                                                data.errArr.includes('Origin') &&
                                                '#ff00002b'
                                            }}
                                          >

                                            <input
                                              type="file"
                                              id={`file${index}`}
                                              ref={this.fileInputRef}
                                              name={`file${index}`}
                                              class="image-upload"
                                              accept=".jpg,.jpeg,.png,.pdf"
                                              hidden
                                              disabled={true}
                                            />

                                            {/* Upload button removed because
                                        the entire form is read-only */}

                                            <div className="text-center">
                                              No document uploaded
                                            </div>

                                          </div>

                                        )

                                      ) : (

                                        <div className='text-center mt-2'></div>

                                      )}

                                    </div>

                                  </div>

                                </div>

                              </div>

                            </fieldset>

                          </div>

                        </div>

                      ))

                    ) : (

                      <div class="accordion-item-exhdetail">

                        <p
                          style={{
                            color: '#000',
                            fontSize: '1.12rem',
                            padding: '15px 20px'
                          }}
                          colSpan={10}
                          className="text-center"
                        >
                          Record not available
                        </p>

                      </div>

                    )}

                  </div>

                </div>

              </div>


              {/* ================= FOOTER ================= */}
              <div className="modal-footer py-1">

                <button
                  type="button"
                  className="btn btn-gray"
                  onClick={() =>
                    this.setState({
                      isExhibitPop: false
                    })
                  }
                >
                  Back
                </button>

              </div>

            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getExhStallPossessionDetails_action,
    updateExhStallPossessionChecklist_action,
    getStallPossession_action,
    insertStallPossession_action,
    sendNoDues_action,
    download_no_due_action,
    tagDDSubmit_action,
    getDetails_spaceBooking_action
  })(StallPossessionChecklistAU)
);
